{
	"dialog.ok": "확인",
	"dialog.cancel": "취소",
	"dialog.confirm": "확인",
	"dialog.close": "닫기",
	"dialog.import": "가져오기",
	"dialog.save": "저장하기",
	"dialog.discard": "나가기",
	"dialog.dontshowagain": "다시 보지 않기",
	"data.cube": "큐브",
	"data.group": "그룹",
	"data.texture": "텍스쳐",
	"data.plugin": "플러그인",
	"data.preview": "미리보기",
	"data.toolbar": "도구 창",
	"data.image": "이미지",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "커맨드 키",
	"keys.delete": "Delete",
	"keys.space": "Space",
	"keys.leftclick": "왼쪽 마우스 클릭",
	"keys.middleclick": "가운데 마우스 클릭",
	"keys.rightclick": "오른쪽 마우스 클릭",
	"keys.tab": "Tab",
	"keys.backspace": "Backspace",
	"keys.enter": "Enter",
	"keys.escape": "Esc",
	"keys.function": "F%0",
	"keys.numpad": "키패드 %0",
	"keys.caps": "Capslock",
	"keys.menu": "Menu",
	"keys.left": "←",
	"keys.up": "↑",
	"keys.right": "→",
	"keys.down": "↓",
	"keys.pageup": "Page Up",
	"keys.pagedown": "Page Down",
	"keys.plus": "+",
	"keys.comma": ",",
	"keys.point": ".",
	"keys.minus": "-",
	"keys.cross": "+",
	"keys.end": "End",
	"keys.pos1": "위치 1",
	"keys.printscreen": "Print Screen",
	"keys.pause": "일시 정지",
	"message.rotation_limit.title": "각도 제한",
	"message.rotation_limit.message": "마인크래프트에서는 각을 22.5도씩만 조절할 수 있습니다. 또한 회전은 한 방향으로만 할 수 있습니다. 다른 목적으로 자유 회전을 이용 하고싶다면 모델을 \"자유 모델\"로 변환하십시오.",
	"message.file_not_found.title": "파일을 찾을 수 없습니다",
	"message.file_not_found.message": "지정된 파일을 불러올 수 없습니다. 클라우드 같은 가상 폴더에 저장된 파일이 아닌지 확인하십시오.",
	"message.screenshot.title": "스크린샷",
	"message.screenshot.clipboard": "클립보드",
	"message.screenshot.right_click": "마우스 오른쪽 버튼으로 클릭하거나 길게 눌러 스크린샷 복사하기",
	"message.invalid_file.title": "유효하지 않은 파일",
	"message.invalid_file.message": "유효하지 않은 .json 파일 : %0",
	"message.invalid_model.title": "유효하지 않은 모델 파일",
	"message.invalid_model.message": "이 파일은 모델에 관련된 파일이 아닙니다.",
	"message.child_model_only.title": "비어있는 자식 모델",
	"message.child_model_only.message": "이 파일은 %0의 자식 모델이며 내용이 없습니다.",
	"message.unsaved_textures.title": "저장되지 않은 텍스쳐",
	"message.unsaved_textures.message": "당신의 모델에는 지정되지 않은 텍스쳐가 포함되어있습니다. 리소스팩 내부의 알맞는 폴더에 텍스쳐를 삽입하십시오.",
	"message.model_clipping.title": "모델이 너무 크면 경고",
	"message.model_clipping.message": "\"%0\"로 지정된 큐브가3x3x3 크기 제한을 넘어가고 있습니다. 이 모델은 마인크래프트에서 사용이 불가능합니다.",
	"message.loose_texture.title": "텍스쳐 가져오기",
	"message.loose_texture.message": "방금 불러온 텍스쳐는 옳지 않은 경로에 있습니다. 마인크래프트에서 정상적으로 불러내기 위해서는 리소스팩 폴더 내부에 텍스쳐가 있어야 합니다.",
	"message.loose_texture.change": "경로 변경하기",
	"message.update_res.title": "텍스쳐 해상도",
	"message.update_res.message": "프로젝트 해상도를 이 텍스쳐의 해상도로 업데이트 하시겠습니까? 텍스쳐의 해상도가 프로젝트보다 높은 경우 '취소'를 클릭하십시오.",
	"message.update_res.update": "업데이트",
	"message.bedrock_overwrite_error.message": "Blockbench가 이전 모델과 이 모델을 합치는데 실패함",
	"message.bedrock_overwrite_error.backup_overwrite": "백업 만들고 덮어쓰기",
	"message.bedrock_overwrite_error.overwrite": "덮어쓰기",
	"message.close_warning.message": "모델을 저장하시겠습니까?",
	"message.close_warning.web": "진행된 작업을 잃을 것입니다. 저장하지 않고 나가시겠습니까?",
	"message.default_textures.title": "기본 텍스쳐",
	"message.default_textures.message": "바닐라 리소스팩의 \"textures\" 폴더를 선택하세요",
	"message.default_textures.detail": "마인크래프트 내부의 jar 파일에서 기본 리소스팩을 추출하거나 웹에서 다운로드 하십시오. 그런 다음 textures 폴더를 찾아 여십시오. Blockbench가 해당 위치를 기억하고 현재 리소스 팩에서 찾을 수없는 경우 기본 리소스팩에서 텍스쳐를 가져옵니다.",
	"message.default_textures.select": "기본 \"textures\" 폴더를 선택하세요",
	"message.image_editor.title": "이미지 편집 프로그램 선택하기",
	"message.image_editor.file": "파일 열기...",
	"message.image_editor.exe": "실행 가능한 이미지 편집 프로그램 선택하기",
	"message.display_skin.title": "스킨 표시",
	"message.display_skin.message": "플레이어 이름을 쓰거나 컴퓨터에서 파일을 골라 스킨 변경",
	"message.display_skin.upload": "스킨 저장",
	"message.display_skin.reset": "초기화",
	"message.invalid_plugin": "잘못된 플러그인입니다. 콘솔을 확인하십시오",
	"message.load_plugin_app": "이 플러그인이 당신의 컴퓨터를 변경할 수 있도록 하용하시겠습니까? 신뢰할 수 있는 플러그인만 불러오십시오.",
	"message.load_plugin_web": "이 플러그인을 불러올까요? 신뢰할 수 있는 플러그인만 불러오십시오.",
	"message.preset_no_info": "사전 설정에서 이 슬롯에 대한 정보가 없음",
	"message.restart_to_update": "Blockbench 재시작",
	"message.save_file": "%0를 저장했습니다",
	"dialog.project.title": "프로젝트",
	"dialog.project.name": "파일 이름",
	"dialog.project.parent": "부모 모델",
	"dialog.project.geoname": "모델 식별자",
	"dialog.project.ao": "앰비언트 오클루전",
	"dialog.texture.title": "텍스쳐",
	"dialog.texture.variable": "변수",
	"dialog.texture.namespace": "이름 공간",
	"dialog.texture.folder": "폴더",
	"dialog.extrude.title": "이미지 압출",
	"dialog.extrude.mode": "읽기 모드",
	"dialog.extrude.mode.areas": "영역",
	"dialog.extrude.mode.lines": "선",
	"dialog.extrude.mode.columns": "열",
	"dialog.extrude.mode.pixels": "픽셀",
	"dialog.extrude.opacity": "최소 투명도",
	"dialog.extrude.scan": "읽기 및 가져오기",
	"dialog.display_preset.title": "사전 설정 추가",
	"dialog.display_preset.message": "저장하고 싶은 슬롯 선택",
	"dialog.display_preset.create": "만들기",
	"dialog.select.title": "선택",
	"dialog.select.group": "선택된 그룹",
	"dialog.select.name": "이름 포함",
	"dialog.select.random": "랜덤",
	"dialog.select.select": "선택",
	"dialog.scale.title": "모델 크기",
	"dialog.scale.axis": "축",
	"dialog.scale.clipping": "모델 클리핑: 모델이 캔버스보다 너무 큽니다.",
	"dialog.scale.confirm": "크기",
	"dialog.plugins.title": "플러그인",
	"dialog.plugins.installed": "설치된 플러그인",
	"dialog.plugins.available": "활성화된 플러그인",
	"dialog.plugins.install": "플러그인 설치",
	"dialog.plugins.uninstall": "플러그인 제거",
	"dialog.plugins.reload": "플러그인 새로고침",
	"dialog.plugins.none_installed": "설치된 플러그인이 없습니다.",
	"dialog.plugins.none_available": "활성화된 플러그인이 없습니다.",
	"dialog.plugins.web_only": "웹 버전 전용",
	"dialog.plugins.app_only": "설치 버전 전용",
	"dialog.plugins.author": "제작 : %0",
	"dialog.create_texture.folder": "폴더",
	"dialog.create_texture.resolution": "텍스쳐 해상도",
	"dialog.input.title": "입력",
	"dialog.settings.settings": "설정",
	"dialog.settings.keybinds": "키 설정",
	"dialog.settings.about": "정보",
	"layout.color.back": "뒤로",
	"layout.color.back.desc": "배경 및 입력창",
	"layout.color.dark": "어두움",
	"layout.color.dark.desc": "캔버스 배경",
	"layout.color.ui": "UI",
	"layout.color.ui.desc": "주 화면 색상",
	"layout.color.bright_ui": "밝은 UI",
	"layout.color.bright_ui.desc": "컨텍스트 메뉴 및 툴팁",
	"layout.color.button": "버튼",
	"layout.color.button.desc": "버튼과 스위치",
	"layout.color.selected": "선택됨",
	"layout.color.selected.desc": "선택 창 및 객체",
	"layout.color.border": "경계",
	"layout.color.border.desc": "입력창 및 버튼의 테두리",
	"layout.color.accent": "강조",
	"layout.color.accent.desc": "슬라이더 바 및 세부사항",
	"layout.color.grid": "격자",
	"layout.color.grid.desc": "3D 미리보기 격자",
	"layout.color.text": "텍스트",
	"layout.color.text.desc": "일반 텍스트",
	"layout.color.light": "빛",
	"layout.color.light.desc": "하이라이트 글씨",
	"layout.color.accent_text": "강조된 글씨",
	"layout.color.accent_text.desc": "밝거나 강조된 요소의 텍스트",
	"layout.font.main": "주 폰트",
	"layout.font.headline": "헤드라인 폰트",
	"about.version": "버전:",
	"settings.category.general": "일반",
	"settings.category.preview": "미리보기",
	"settings.category.grid": "격자",
	"settings.category.edit": "편집",
	"settings.category.snapping": "스내핑",
	"settings.category.defaults": "기본",
	"settings.category.dialogs": "대화 상자",
	"settings.category.export": "내보내기 설정",
	"settings.language": "언어",
	"settings.language.desc": "언어. 변경 사항을 적용하려면 Blockbench 재시작 필요",
	"settings.backup_interval": "백업 주기",
	"settings.backup_interval.desc": "분당 자동 백업 주기",
	"settings.origin_size": "회전 중심 표시",
	"settings.origin_size.desc": "회전 중심을 보여주는 선의 길이 조절",
	"settings.control_size": "축 화살표 크기 조절",
	"settings.control_size.desc": "각 축에 달린 화살표의 크기 조절",
	"settings.display_skin": "스킨 표시",
	"settings.display_skin.desc": "참고 플레이어 모델에 사용되는 스킨",
	"settings.shading": "셰이딩",
	"settings.shading.desc": "프리뷰에서 셰이딩 허용",
	"settings.base_grid": "작은 격자",
	"settings.base_grid.desc": "작은 격자를 표시합니다.",
	"settings.large_grid": "블록 격자",
	"settings.large_grid.desc": "16x16 크기의 블록 격자 표시",
	"settings.full_grid": "정확한 블록 격자",
	"settings.full_grid.desc": "픽셀의 정확한 블록 격자 표시",
	"settings.large_box": "중간 박스",
	"settings.large_box.desc": "3x3x3 칸의 블록 경계 표시",
	"settings.display_grid": "보기 모드",
	"settings.display_grid.desc": "디스플레이 모드에서도 격자 표시",
	"settings.undo_limit": "실행 취소 한계",
	"settings.undo_limit.desc": "실행 취소 횟수 제한",
	"settings.local_move": "상대적으로 축 이동",
	"settings.local_move.desc": "가능한 경우 회전된 요소는 각자의 축으로 이동",
	"settings.canvas_unselect": "캔버스 클릭 해제",
	"settings.canvas_unselect.desc": "바탕 클릭 시 전체 선택 해제",
	"settings.paint_side_restrict": "브러시 옆으로 제한",
	"settings.paint_side_restrict.desc": "브러시가 현재 면에만 칠하도록 제한",
	"settings.autouv": "자동 UV",
	"settings.autouv.desc": "자동 UV를 기본으로 허용",
	"settings.create_rename": "요소 이름 바꾸기",
	"settings.create_rename.desc": "요소 또는 그룹을 생성할 때 이름 강조",
	"settings.edit_size": "격자 크기",
	"settings.edit_size.desc": "요소 이동 거리",
	"settings.shift_size": "Shift 단위",
	"settings.shift_size.desc": "움직이거나 이동할때 Shift를 누를 때의 단위",
	"settings.ctrl_size": "Ctrl 단위",
	"settings.ctrl_size.desc": "움직이거나 이동할때 Ctrl를 누를 때의 단위",
	"settings.negative_size": "음(-)의 크기",
	"settings.negative_size.desc": "크기 조정 시 음수 허용",
	"settings.minifiedout": "최소화 된 내보내기",
	"settings.minifiedout.desc": "한줄에 넣기",
	"settings.export_groups": "자바 블록/아이템 모델로 그룹 내보내기",
	"settings.export_groups.desc": "그룹을 자바 블록 또는 아이템 모델 JSON 파일로 저장",
	"settings.credit": "크레딧 ",
	"settings.credit.desc": "내보낸 파일에 크레딧 설명 추가",
	"settings.default_path": "기본 마인크래프트 텍스쳐 위치",
	"settings.default_path.desc": "기본 텍스쳐 폴더",
	"settings.image_editor": "이미지 편집기",
	"settings.image_editor.desc": "텍스쳐를 편집할 기본 이미지 편집기",
	"category.navigate": "찾기",
	"category.tools": "도구",
	"category.file": "파일",
	"category.blockbench": "Blockbench",
	"category.edit": "편집",
	"category.transform": "변환",
	"category.view": "보기",
	"category.display": "보기 설정",
	"category.textures": "텍스쳐",
	"category.misc": "여러가지",
	"keybind.preview_select": "선택",
	"keybind.preview_rotate": "보는 각도 조정",
	"keybind.preview_drag": "드래그 보기",
	"keybind.confirm": "확인",
	"keybind.cancel": "취소",
	"action.slider_inflate": "부풀리기",
	"action.slider_inflate.desc": "UV 변화 없이 큐브의 크기를 확장",
	"action.slider_brush_size": "크기",
	"action.slider_brush_size.desc": "브러시 굵기 (픽셀 단위)",
	"action.slider_brush_opacity": "투명도",
	"action.slider_brush_opacity.desc": "브러시 투명도 조절 (0에서 255)",
	"action.slider_brush_softness": "부드러움",
	"action.slider_brush_softness.desc": "브러시 부드러움 (백분율)",
	"action.uv_slider_pos_x": "좌우로 이동",
	"action.uv_slider_pos_x.desc": "선택된 큐브의 UV 수평 이동",
	"action.uv_slider_pos_y": "상하로 이동",
	"action.uv_slider_pos_y.desc": "선택된 큐브의 UV 수직 이동",
	"action.uv_slider_size_x": "수평 크기",
	"action.uv_slider_size_x.desc": "선택된 큐브의 UV의 수평 크기 조절",
	"action.uv_slider_size_y": "수직 크기",
	"action.uv_slider_size_y.desc": "선택된 큐브의 UV의 수직 크기 조절",
	"action.vertex_snap_mode": "맞춤 모드",
	"action.vertex_snap_mode.desc": "꼭짓점을 이동하거나 크기 조절 시 선택",
	"action.move_tool": "이동",
	"action.move_tool.desc": "선택 및 이동 도구",
	"action.resize_tool": "크기 조정",
	"action.resize_tool.desc": "선택 및 크기 조절 도구",
	"action.brush_tool": "페인트 브러시",
	"action.brush_tool.desc": "표면 또는 UV 에디터의 비트맵 텍스쳐에 칠을 하는 도구",
	"action.vertex_snap_tool": "꼭짓점 맞춤",
	"action.vertex_snap_tool.desc": "두 큐브를 꼭짓점을 기준으로 맞춥니다",
	"action.swap_tools": "교환 도구",
	"action.swap_tools.desc": "이동 및 크기 조정 도구 간 전환",
	"action.project_window": "프로젝트...",
	"action.project_window.desc": "모델의 메타데이터를 편집할 수 있는 프로젝트 창 열기",
	"action.open_model": "모델 열기",
	"action.open_model.desc": "내 컴퓨터에서 모델 찾기",
	"action.extrude_texture": "압출된 텍스쳐",
	"action.extrude_texture.desc": "텍스쳐를 늘려 모델 생성",
	"action.export_blockmodel": "블록/아이템 모델 내보내기",
	"action.export_blockmodel.desc": "마인크래프트 자바 에디션용 블록/아이템 모델 내보내기",
	"action.export_optifine_part": "OptiFine 부위 내보내기",
	"action.export_optifine_part.desc": "OptiFine 엔티티 모델 부위 단일 내보내기",
	"action.export_optifine_full": "OptiFine JEM 내보내기",
	"action.export_optifine_full.desc": "OptiFine 엔티티 모델 전체 내보내기",
	"action.export_obj": ".OBJ 내보내기",
	"action.export_obj.desc": "렌더링용 Wavefront 객체 내보내기",
	"action.settings_window": "설정..",
	"action.settings_window.desc": "Blockbench 설정 대화 상자 열기",
	"action.plugins_window": "플러그인",
	"action.plugins_window.desc": "플러그인 스토어 메뉴를 엽니다.",
	"action.reset_layout": "레이아웃 초기화",
	"action.reset_layout.desc": "Blockbench 기본으로 레이아웃 초기화",
	"action.load_plugin": "파일에서 플러그인 로드",
	"action.load_plugin.desc": "소스 파일 불러오기로 플러그인 로드",
	"action.reload_plugins": "플러그인 새로고침",
	"action.reload_plugins.desc": "모든 개발 플러그인 새로 고침",
	"action.undo": "되돌리기",
	"action.undo.desc": "마지막으로 진행한 작업 취소",
	"action.redo": "실행 취소",
	"action.redo.desc": "마지막 되돌리기 작업 취소",
	"action.copy": "복사",
	"action.copy.desc": "선택한 범위 복사",
	"action.paste": "붙여넣기",
	"action.paste.desc": "선택한 범위 붙여넣기",
	"action.cut": "잘라내기",
	"action.cut.desc": "선택한 범위 잘라내기",
	"action.add_cube": "큐브 추가",
	"action.add_cube.desc": "새로운 큐브 추가",
	"action.add_group": "그룹 추가",
	"action.add_group.desc": "새로운 그룹 또는 뼈대 추가",
	"action.outliner_toggle": "추가 옵션 전환",
	"action.outliner_toggle.desc": "외곽선 추가 옵션 스위치 전환",
	"action.duplicate": "복제",
	"action.delete": "삭제",
	"action.sort_outliner": "외곽선 정렬",
	"action.sort_outliner.desc": "알파벳 순으로 외곽선 정렬",
	"action.select_window": "선택...",
	"action.select_window.desc": "속성 기반 큐브 선택 및 검색",
	"action.invert_selection": "선택 반전",
	"action.invert_selection.desc": "현재 선택된 큐브 반전",
	"action.select_all": "모두 선택",
	"action.collapse_groups": "그룹 닫기",
	"action.collapse_groups.desc": "모든 그룹 닫기",
	"action.scale": "크기 조정...",
	"action.scale.desc": "선택된 큐브 크기",
	"action.toggle_visibility": "가시성 전환",
	"action.toggle_visibility.desc": "선택된 큐브 가시성 전환",
	"action.toggle_export": "내보내기 전환",
	"action.toggle_export.desc": "선택된 큐브 내보내기 설정 전환",
	"action.toggle_autouv": "자동 UV 전환",
	"action.toggle_autouv.desc": "선택된 큐브 자동 UV 전환",
	"action.toggle_shade": "셰이딩 전환",
	"action.toggle_shade.desc": "선택된 큐브 셰이딩 전환",
	"action.rename": "이름 바꾸기",
	"action.rename.desc": "선택된 큐브 이름 바꾸기",
	"action.add_display_preset": "새 사전 설정",
	"action.add_display_preset.desc": "새로운 사전 표기 설정 추가",
	"action.fullscreen": "전체 화면",
	"action.fullscreen.desc": "전체 화면 전환",
	"action.zoom_in": "확대",
	"action.zoom_in.desc": "인터페이스의 크기 확대",
	"action.zoom_out": "축소",
	"action.zoom_out.desc": "인터페이스의 크기 축소",
	"action.zoom_reset": "확대/축소 초기화",
	"action.zoom_reset.desc": "확대/축소를 기본 100%로 초기화",
	"action.reset_interface": "작업 화면 초기화",
	"action.reset_interface.desc": "GUI 크기 및 위치 초기화",
	"action.screenshot_model": "스크린샷 모델",
	"action.screenshot_model.desc": "현재 각도에서 모델 스크린샷 자르기",
	"action.screenshot_app": "스크린샷 앱",
	"action.screenshot_app.desc": "애플리케이션 전체 스크린샷",
	"action.import_texture": "텍스쳐 불러오기",
	"action.import_texture.desc": "내 파일에서 하나 이상의 텍스쳐 가져오기",
	"action.create_texture": "텍스쳐 생성",
	"action.create_texture.desc": "빈 텍스쳐 또는 템플릿 텍스쳐 생성",
	"action.save_textures": "텍스쳐 저장",
	"action.save_textures.desc": "저장하지 않은 모든 텍스쳐 저장",
	"action.animated_textures": "텍스쳐 애니메이션 재생",
	"action.animated_textures.desc": "텍스쳐 미리보기의 애니메이션을 재생 또는 정지",
	"action.origin_to_geometry": "중앙 회전 중심",
	"action.origin_to_geometry.desc": "회전 중심을 선택 중심으로 설정",
	"action.bone_reset_toggle": "뼈대 초기화",
	"action.bone_reset_toggle.desc": "뼈대가 부모 모델에서 큐브를 표시하지 않도록 중지",
	"action.reload": "Blockbench 새로 고침",
	"action.reload.desc": "Blockbench 새로 고침. 저장되지 않은 변경 사항은 복구할 수 없음",
	"menu.file": "파일",
	"menu.edit": "편집",
	"menu.transform": "변환",
	"menu.display": "보기",
	"menu.view": "보기",
	"menu.file.new": "새 모델",
	"menu.file.recent": "최근 작업물",
	"menu.file.import": "가져오기",
	"menu.file.export": "내보내기",
	"menu.transform.rotate": "회전",
	"menu.transform.flip": "뒤집기",
	"menu.transform.center": "중앙으로",
	"menu.transform.properties": "속성",
	"menu.display.preset": "사전 설정 적용",
	"menu.display.preset_all": "사전 설정 전체 적용",
	"menu.display.remove_preset": "사전 설정 제거",
	"menu.view.zoom": "확대하기",
	"menu.view.background": "배경화면",
	"menu.view.screenshot": "스크린샷",
	"menu.cube.color": "지정 색",
	"menu.cube.texture": "텍스쳐",
	"menu.cube.texture.transparent": "투명",
	"menu.cube.texture.blank": "비어있음",
	"menu.group.sort": "분류",
	"menu.texture.face": "한 면에 적용",
	"menu.texture.file": "파일",
	"menu.texture.refresh": "텍스쳐 새로고침",
	"menu.texture.change": "파일 바꾸기",
	"menu.texture.folder": "폴더에서 열기",
	"menu.texture.edit": "외부적으로 수정",
	"menu.texture.export": "다른 이름으로 저장",
	"menu.texture.save": "저장",
	"menu.texture.properties": "환경 설정...",
	"menu.preview.background": "배경",
	"menu.preview.background.load": "불러오기",
	"menu.preview.background.position": "위치",
	"menu.preview.background.lock": "카메라 잠금",
	"menu.preview.screenshot": "스크린샷",
	"menu.preview.perspective": "원근감",
	"menu.preview.perspective.normal": "일반",
	"menu.preview.quadview": "사면 보기",
	"menu.preview.stop_drag": "배경 위치 중지",
	"menu.uv.mapping.rotation": "회전",
	"menu.uv.texture": "텍스쳐",
	"cube.color.light_blue": "하늘색",
	"cube.color.yellow": "노랑색",
	"cube.color.orange": "주황색",
	"cube.color.red": "빨강색",
	"cube.color.purple": "보라색",
	"cube.color.blue": "파랑색",
	"cube.color.green": "초록색",
	"cube.color.lime": "연두색",
	"switches.visibility": "가시성",
	"switches.export": "내보내기",
	"switches.autouv": "자동 UV",
	"panel.uv": "UV",
	"panel.display": "디스플레이",
	"panel.textures": "텍스쳐",
	"panel.outliner": "외곽선",
	"uv_editor.title": "UV 편집기",
	"uv_editor.all_faces": "전체",
	"uv_editor.no_faces": "없음",
	"face.north": "북쪽",
	"face.south": "남쪽",
	"face.west": "서쪽",
	"face.east": "동쪽",
	"face.up": "위",
	"face.down": "아래",
	"direction.north": "북쪽",
	"direction.south": "동쪽",
	"direction.west": "서쪽",
	"direction.east": "동쪽",
	"direction.top": "위",
	"direction.bottom": "아래",
	"display.slot.third_right": "3인칭 우측",
	"display.slot.third_left": "3인칭 좌측",
	"display.slot.first_right": "1인칭 우측",
	"display.slot.first_left": "1인칭 좌측",
	"display.slot.head": "머리",
	"display.slot.ground": "땅",
	"display.slot.frame": "틀",
	"display.slot.gui": "GUI",
	"display.rotation": "회전",
	"display.translation": "위치",
	"display.scale": "규모",
	"display.slot": "슬롯",
	"display.reference": "참고 모델",
	"display.reference.player": "플레이어",
	"display.reference.zombie": "좀비",
	"display.reference.armor_stand": "갑옷 거치대",
	"display.reference.baby_zombie": "아기 좀비",
	"display.reference.armor_stand_small": "작은 갑옷 거치대",
	"display.reference.monitor": "일반",
	"display.reference.bow": "굽히기",
	"display.reference.block": "블록",
	"display.reference.frame": "아이템 액자",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "인벤토리",
	"display.reference.hud": "HUD",
	"display.preset.blank_name": "이름을 입력해주세요.",
	"display.preset.item": "기본 아이템",
	"display.preset.block": "기본 블록",
	"display.preset.handheld": "기본 무기",
	"display.preset.rod": "기본 막대",
	"dialog.continue": "계속",
	"message.square_textures": "텍스쳐는 정사각형이어야 합니다.",
	"message.unsaved_texture.title": "저장되지 않은 텍스쳐",
	"message.unsaved_texture.message": "이 텍스쳐에 대한 변경 사항은 전부 지워질 것입니다. 계속하시겠습니까?",
	"action.vertex_snap_mode.move": "이동",
	"action.vertex_snap_mode.scale": "크기",
	"action.open_model_folder": "모델 폴더 열기",
	"action.open_model_folder.desc": "모델이 포함된 폴더 열기",
	"action.change_textures_folder": "텍스쳐 위치 변경",
	"action.change_textures_folder.desc": "텍스쳐가 저장된 폴더 바꾸기",
	"menu.texture.particle": "파티클로 사용",
	"message.update_notification.title": "업데이트를 설치할 수 없습니다",
	"message.update_notification.message": "Blockbench의 새로운 버전 \"%0\"을 사용할 수 있습니다. 업데이트를 위해 자동 업데이트 설정을 허용해주세요!",
	"message.untextured": "이 표면은 텍스쳐가 없습니다",
	"dialog.toolbar_edit.title": "툴바 사용자 설정",
	"keybindings.reset": "초기화",
	"keybindings.clear": "없음",
	"action.cube_counter": "모델 통계",
	"action.uv_rotation": "UV 회전",
	"action.uv_rotation.desc": "UV 표면의 각도",
	"action.uv_grid": "UV 격자",
	"action.uv_grid.desc": "UV 선택기가 스냅하는 격자의 해상도",
	"action.uv_grid.auto": "자동",
	"action.uv_maximize": "UV 최대화",
	"action.uv_maximize.desc": "이 표면의 UV를 전체 텍스쳐로 설정",
	"action.uv_auto": "자동 UV",
	"action.uv_auto.desc": "이 표면의 UV 크기를 표면의 실제 크기로 설정",
	"action.uv_rel_auto": "상대적 자동 UV",
	"action.uv_rel_auto.desc": "이 표면의 UV를 실제 표면의 위치 및 크기로 설정",
	"action.uv_mirror_x": "X로 UV 좌우반전",
	"action.uv_mirror_x.desc": "X축에서 이 표면의 UV를 좌우반전",
	"action.uv_mirror_y": "Y로 UV 좌우반전",
	"action.uv_mirror_y.desc": "Y축에서 이 표면의 UV를 좌우반전",
	"action.uv_transparent": "표면 제거",
	"action.uv_transparent.desc": "현재 표면 제거",
	"action.uv_reset": "표면 초기화",
	"action.uv_reset.desc": "현재 표면 초기화",
	"action.cullface": "후면 제거",
	"action.cullface.desc": "선택한 모델의 측면이 덮인 경우 이 면에 대한 렌더링 비활성화",
	"action.auto_cullface": "후면 제거 키기",
	"action.auto_cullface.desc": "이 표면의 후면 제거를 자체로 설정",
	"action.face_tint": "색조",
	"action.face_tint.desc": "현재 표면에 대한 색조 옵션을 사용 가능으로 설정",
	"menu.toolbar.edit": "사용자 정의",
	"menu.toolbar.reset": "초기화",
	"uv_editor.rotated": "기울여짐",
	"uv_editor.auto_cull": "수동 후면 제거",
	"uv_editor.copied": "표면 복사됨",
	"uv_editor.pasted": "표면 붙여넣어짐",
	"uv_editor.copied_x": "%0 표면 복사됨",
	"uv_editor.reset": "표면 초기화",
	"uv_editor.maximized": "최대화됨",
	"uv_editor.autouv": "자동 크기",
	"uv_editor.mirrored": "좌우반전됨",
	"uv_editor.to_all": "모든 표면에 적용",
	"uv_editor.transparent": "투명하게 만들기",
	"uv_editor.cullface_on": "후면 제거 키기",
	"uv_editor.cullface_off": "후면 제거 끄기",
	"uv_editor.tint_on": "옅은 색 키기",
	"uv_editor.tint_off": "옅은 색 끄기",
	"action.uv_apply_all": "모든 표면에 적용",
	"action.uv_apply_all.desc": "현재 표면의 설정을 모든 면에 적용",
	"message.image_editor_missing.title": "기본 이미지 에디터",
	"message.image_editor_missing.message": "이미지 편집기의 실행 파일을 선택",
	"message.image_editor_missing.detail": "Blockbench는 컴퓨터에서 이미지 편집기를 찾을 수 없습니다. 원하는 이미지 편집기의 실행 파일을 선택하십시오.",
	"action.update_autouv": "자동 UV 업데이트",
	"action.update_autouv.desc": "선택한 큐브의 자동 UV 매핑 업데이트",
	"category.uv": "UV",
	"status_bar.saved": "모델 저장됨",
	"status_bar.unsaved": "저장되지 않은 변경이 있습니다.",
	"action.move_up": "위로",
	"action.move_up.desc": "선택한 큐브를 현재 카메라 각도에 대해 위로 이동",
	"action.move_down": "아래로",
	"action.move_down.desc": "선택한 큐브를 현재 카메라 각도에 대해 아래로 이동",
	"action.move_left": "옆으로",
	"action.move_left.desc": "선택한 큐브를 현재 카메라 각도에 대해 왼쪽으로 이동",
	"action.move_right": "오른쪽으로",
	"action.move_right.desc": "선택한 큐브를 현재 카메라 각도에 대해 오른쪽으로 이동",
	"action.move_forth": "앞으로",
	"action.move_forth.desc": "선택한 큐브를 현재 카메라 각도에 대해 앞으로 이동",
	"action.move_back": "뒤로",
	"action.move_back.desc": "선택한 큐브를 현재 카메라 각도에 대해 뒤로 이동",
	"layout.color.wireframe": "와이어프레임",
	"layout.color.wireframe.desc": "와이어프레임 선 보기",
	"layout.color.wireframe_selectable": "선택 가능한 와이어프레임",
	"layout.color.wireframe_selectable.desc": "편집 모드에서 활성 메시의 선택되지 않은 모서리 및 정점",
	"action.add_animation": "애니메이션 추가",
	"action.add_animation.desc": "빈 애니메이션 생성",
	"action.load_animation_file": "애니메이션 가져오기",
	"action.load_animation_file.desc": "애니메이션 파일 가져오기",
	"action.play_animation": "애니메이션 재생",
	"action.play_animation.desc": "애니메이션 미리 보기",
	"action.slider_keyframe_time": "타임코드",
	"action.slider_keyframe_time.desc": "선택한 키프레임의 타임코드 변경",
	"timeline.rotation": "회전",
	"timeline.position": "위치",
	"timeline.scale": "크기",
	"menu.keyframe.quaternion": "쿼터니언",
	"panel.animations": "애니메이션",
	"panel.keyframe": "키프레임",
	"panel.keyframe.type": "키프레임 (%0)",
	"generic.delete": "삭제",
	"generic.rename": "이름 바꾸기",
	"message.no_animation_selected": "이 작업을 하려면 애니메이션을 선택 해야합니다.",
	"message.no_bone_selected": "이 작업을 하려면 뼈대를 선택 해야합니다.",
	"message.duplicate_groups.title": "뼈대 이름 복제",
	"message.duplicate_groups.message": "이 뼈대의 이름은 여러 개의 뼈대에 존재합니다. 이것은 문제를 일으킬 수 있습니다",
	"action.delete_keyframes": "키프레임 삭제",
	"action.delete_keyframes.desc": "선택된 키프레임 삭제",
	"menu.animation": "애니메이션",
	"menu.animation.loop": "루프 만들기",
	"menu.animation.override": "재정의",
	"menu.animation.anim_time_update": "애니메이션 시간 업데이트",
	"message.display_skin_model.title": "스킨 모델",
	"message.display_skin_model.message": "스킨의 모델 종류를 고르세요.",
	"message.display_skin_model.classic": "일반",
	"message.display_skin_model.slim": "슬림",
	"message.bone_material": "뼈대 물질 바꾸기",
	"action.slider_animation_length": "애니메이션 길이",
	"action.slider_animation_length.desc": "선택된 애니메이션 길이 바꾸기",
	"panel.variable_placeholders": "변수 플레이스홀더",
	"panel.variable_placeholders.info": "이름=값을 통해 미리 볼 변수 나열",
	"status_bar.vertex_distance": "거리: %0",
	"dialog.create_gif.title": "녹화된 GIF",
	"dialog.create_gif.length": "길이",
	"dialog.create_gif.fps": "프레임",
	"dialog.create_gif.play": "애니메이션 시작",
	"category.animation": "애니메이션",
	"action.record_model_gif": "GIF로 녹화...",
	"action.record_model_gif.desc": "현재 각도에서 모델의 애니메이션 GIF 녹화",
	"display.mirror": "좌우반전",
	"data.separator": "분리기",
	"menu.preview.background.set_position": "위치 설정",
	"dialog.toolbar_edit.hidden": "숨김",
	"action.export_class_entity": "Java 엔티티 내보내기",
	"action.export_class_entity.desc": "Java classs로 엔티티 모델 내보내기",
	"settings.seethrough_outline": "외곽선 X-Ray",
	"settings.seethrough_outline.desc": "객체 뒤로 외곽선을 표시합니다.",
	"mode.edit": "편집",
	"mode.paint": "칠하기",
	"mode.display": "디스플레이",
	"mode.animate": "애니메이션",
	"status_bar.recording_gif": "GIF 녹화 중",
	"status_bar.processing_gif": "GIF 처리 중",
	"settings.backup_retain": "복사본 보존 기간",
	"settings.backup_retain.desc": "오래된 복사본 최대 보존 기간 설정",
	"action.rotate_tool": "회전",
	"action.rotate_tool.desc": "선택한 요소를 회전하는 도구",
	"action.fill_tool": "채우기",
	"action.fill_tool.desc": "한 면을 선택한 색상으로 채우기",
	"action.eraser": "지우개",
	"action.eraser.desc": "투명하게 지우는 지우개",
	"action.color_picker": "색 추출",
	"action.color_picker.desc": "색 지정 도구",
	"switches.mirror": "UV 반전",
	"language_name": "한국어",
	"message.plugin_reload": "%0 개의 플러그인을 새로고침 했습니다.",
	"settings.brightness": "밝기",
	"settings.brightness.desc": "프리뷰 밝기. 기본값 50",
	"menu.preview.perspective.reset": "카메라 초기화",
	"action.fill_mode": "채우기 모드",
	"action.fill_mode.face": "면",
	"action.fill_mode.color": "색깔",
	"action.toggle_mirror_uv": "UV 반전",
	"action.toggle_mirror_uv.desc": "선택한 큐브의 X축에서 UV 미러링 토글",
	"menu.texture.blank": "텍스쳐가 없는 표면에 적용",
	"dialog.scale.select_overflow": "오버플로우 선택",
	"action.action_control": "행동 제어",
	"action.action_control.desc": "사용 가능한 모든 행동을 검색하고 실행",
	"keybindings.recording": "키바인딩 녹화중",
	"keybindings.press": "키 또는 키 조합을 누르거나 화면의 아무 곳이나 클릭하여 키 바인딩을 기록하세요.",
	"action.pivot_tool": "회전 중심 도구",
	"action.pivot_tool.desc": "큐브 및 뼈대의 회전 중심 포인트를 변경하는 도구",
	"action.slider_animation_speed": "재생 속도",
	"action.slider_animation_speed.desc": "타임라인의 재생 속도 (퍼센트)",
	"action.previous_keyframe": "이전 키프레임",
	"action.previous_keyframe.desc": "이전 키프레임으로 건너뛰기",
	"action.next_keyframe": "디음 키프레임",
	"action.next_keyframe.desc": "다음 키프레임으로 건너뛰기",
	"message.outdated_client.title": "업데이트 되지 않은 클라이언트",
	"message.outdated_client.message": "이 작업을 하려면 Blockbench를 최신 버전으로 업데이트해야 합니다.",
	"action.export_asset_archive": "압축파일 다운로드",
	"action.export_asset_archive.desc": "모델과 모든 텍스쳐가 포함된 압축 파일을 다운로드",
	"action.upload_sketchfab": "Sketchfab 업로드",
	"message.sketchfab.name_or_token": "Sketchfab 토큰과 이름 입력",
	"dialog.sketchfab_uploader.title": "Sketchfab 모델 업로드",
	"dialog.sketchfab_uploader.token": "API 토큰",
	"dialog.sketchfab_uploader.about_token": "토큰은 Blockbench를 Sketchfab 계정에 연결하는 데 사용됩니다. %0에서 찾을 수 있습니다.",
	"dialog.sketchfab_uploader.name": "모델 이름",
	"dialog.sketchfab_uploader.description": "설명",
	"dialog.sketchfab_uploader.tags": "태그",
	"settings.sketchfab_token": "Sketchfab 토큰",
	"settings.sketchfab_token.desc": "Blockbench에 Sketchfab 계정을 업로드할 수 있는 권한을 부여하는 토큰",
	"panel.color": "색상",
	"data.origin": "회전 중심",
	"message.sketchfab.success": "모델을 성공적으로 업로드하였습니다",
	"message.sketchfab.error": "Sketchfab에 업로드를 실패하였습니디",
	"settings.outliner_colors": "외곽선 색상",
	"settings.outliner_colors.desc": "외곽선에 있는 요소의 색상 표시",
	"action.upload_sketchfab.desc": "Sketchfab에 자신의 모델 업로드",
	"action.element_colors": "큐브 색상",
	"action.element_colors.desc": "외곽선에 있는 큐브의 색상 표시",
	"texture.error.file": "파일이 존재하지 않습니다",
	"texture.error.parent": "상위의 모델에서 제공하는 텍스쳐 파일",
	"message.recover_backup.title": "모델 복구",
	"message.recover_backup.message": "Blockbench가 저장되지 않고 종료되었습니다. 모델을 복구하시겠습니까?",
	"message.invalid_session.title": "잘못된 세션 토큰",
	"message.invalid_session.message": "가입하려는 세션이 만료되었거나 제공된 토큰이 잘못되었습니다.",
	"dialog.create_texture.power": "힘 크기 2",
	"dialog.create_gif.turn": "턴테이블 속도",
	"action.edit_session": "세션 수정",
	"action.edit_session.desc": "편집 세션에 연결하여 다른 사용자와 협업",
	"action.reset_keyframe": "키프레임 초기화",
	"action.reset_keyframe.desc": "선택한 키프레임의 모든 값을 재설정",
	"dialog.edit_session.title": "세션 수정",
	"edit_session.username": "닉네임",
	"edit_session.token": "토큰",
	"edit_session.about": "세션 편집은 인터넷을 통한 모델에서 공동 작업하는 데 사용될 수 있습니다. 세션을 만들고 토큰을 복사하여 친구에게 보내면, 토큰을 사용하여 가입할 수 있습니다.",
	"edit_session.join": "세션 들어가기",
	"edit_session.create": "세션 만들기",
	"edit_session.quit": "세션 나가기",
	"edit_session.joined": "%0 (이)가 세션에 들어왔습니다.",
	"edit_session.left": "&0 이(가) 세션에서 나갔습니다.",
	"edit_session.quit_session": "현재 세션 나가기",
	"edit_session.status": "상태",
	"edit_session.hosting": "호스팅",
	"edit_session.connected": "세션에 연결됨",
	"dialog.sketchfab_uploader.private": "개인 (Pro)",
	"dialog.sketchfab_uploader.password": "비밀번호 (Pro)",
	"action.uv_select_all": "모두 선택",
	"action.uv_select_all.desc": "UV 다아얼로그에서 모든 면을 선택",
	"panel.chat": "채팅",
	"edit_session.welcome": "이 세션에 %0 으로 오신 것을 환영합니다",
	"dialog.yes": "예",
	"dialog.no": "아니오",
	"generic.remove": "삭제",
	"generic.download": "다운로드",
	"generic.search": "검색",
	"dates.today": "오늘",
	"dates.yesterday": "어제",
	"dates.this_week": "이번 주",
	"dates.weeks_ago": "%0 주 지남",
	"mode.start.new": "새 모델",
	"mode.start.recent": "최근",
	"format.free": "자유 모델",
	"format.free.desc": "게임 엔진이나 렌더링 등을 위한 제한 없는 모델",
	"format.java_block": "자바 블록/아이템",
	"format.java_block.desc": "자바 에디션을 위한 모델 형식입니다.",
	"format.bedrock": "베드락 모델",
	"format.bedrock.desc": "베드락 에디션을 위한 모델 형식",
	"format.bedrock_old": "베드락 레거시 모델",
	"format.bedrock_old.desc": "Pre-1.12 베드락 에디션 엔티티 모델",
	"format.modded_entity": "수정된 엔티티",
	"format.modded_entity.desc": "마인크래프트 모드를 위한 엔티티 모델입니다. .java 클래스 파일로 내보낼 수 있습니다.",
	"format.optifine_entity": "OptiFine 엔티티",
	"format.optifine_entity.desc": "OptiFine 모드를 위한 커스텀 엔티티 모델 형식",
	"keys.mouse": "마우스 버튼 %0",
	"message.cleared_blank_faces.title": "비어있는 표면",
	"message.cleared_blank_faces.message": "Blockbench에서 텍스쳐가 없는 %0개의 큐브를 발견했습니다. 이 요소들을 제거하시겠습니까?",
	"message.wireframe.enabled": "와이어프레임 뷰 활성화",
	"message.wireframe.disabled": "와이어프레임 뷰 비활성화",
	"dialog.convert_project.title": "프로젝트 변환",
	"dialog.create_texture.double_use": "다중 텍스쳐 점유 유지",
	"dialog.model_stats.title": "모델 상태",
	"dialog.model_stats.cubes": "큐브들",
	"dialog.model_stats.locators": "로케이터",
	"dialog.model_stats.groups": "그룹들",
	"dialog.model_stats.vertices": "정점",
	"dialog.model_stats.faces": "표면들",
	"settings.username": "닉네임",
	"settings.username.desc": "수정된 세션을 위한 닉네임",
	"settings.painting_grid": "격자 칠하기",
	"settings.painting_grid.desc": "페인트 모드에서 텍스쳐가 있는 큐브에 격자 표시",
	"action.convert_project": "프로젝트 변환",
	"action.convert_project.desc": "현재 프로젝트를 다른 파일 형식으로 변환",
	"action.close_project": "프로젝트 닫기",
	"action.close_project.desc": "현재 열려있는 프로젝트 닫기",
	"action.export_bedrock": "베드락 지오메트리 내보내기",
	"action.export_bedrock.desc": "베드락 지오메트리 파일로 모델 내보내기.",
	"action.save_project": "프로젝트 저장",
	"action.save_project.desc": "현재 프로젝트를 파일로 저장",
	"action.save_project_as": "다른 이름으로 프로젝트 저장",
	"action.save_project_as.desc": "새로운 곳에 현재 프로젝트를 저장",
	"action.export_over": "모델 저장",
	"action.export_over.desc": "파일을 덮어쓰고 모델, 텍스쳐 및 애니메이션 저장",
	"action.add_locator": "로케이터 추가",
	"action.add_locator.desc": "입자, 리쉬 등을 제어하기 위한 새 로케이터 추가",
	"action.uv_turn_mapping": "매핑 전환",
	"action.uv_turn_mapping.desc": "UV 매핑을 90도 정도 돌리기",
	"action.remove_blank_faces": "빈 표면 지우기",
	"action.remove_blank_faces.desc": "텍스쳐가 없는 모든 면 제거",
	"web.download_app": "앱 다운로드",
	"uv_editor.turned": "매핑 전환함",
	"display.reference.crossbow": "크로스보우",
	"dialog.settings.search_results": "검색 결과",
	"settings.animation_snap": "애니메이션 스냅",
	"settings.animation_snap.desc": "애니메이션 타임라인의 키프레임에 대한 기본 스냅 간격(초당 단계)입니다. 애니메이션별로 변경할 수도 있습니다. 기본값은 24입니다.",
	"action.import_optifine_part": "OptiFine 부위 불러오기",
	"action.import_optifine_part.desc": "OptiFine을 위한 엔티티 부위 불러오기",
	"data.locator": "로케이터",
	"mode.start.no_recents": "최근에 열린 모델 없음",
	"panel.element": "요소",
	"panel.element.position": "위치",
	"panel.element.size": "크기",
	"panel.element.origin": "회전 중심 포인트",
	"panel.element.rotation": "각도",
	"message.canvas_limit_error.title": "캔버스 제한 오류",
	"message.canvas_limit_error.message": "형식이 캔버스를 48 단위로 제한하기 때문에 작업을 올바르게 수행할 수 없습니다. 회전 중심 포인트를 변경하여 이 문제를 방지할 수 있습니다.",
	"data.effect": "효과",
	"generic.name": "이름",
	"settings.recent_projects": "최근 모델 캡",
	"settings.recent_projects.desc": "저장되어야하는 최근 모델의 최대 수",
	"settings.volume": "음량",
	"settings.volume.desc": "애니메이션 음향효과 볼륨 제어",
	"action.clear_timeline": "타임라인 초기화",
	"action.clear_timeline.desc": "타임라인에서 선택되지 않은 뼈대 모두 지우기",
	"action.select_effect_animator": "에니매이션 효과",
	"action.select_effect_animator.desc": "타임라인을 열어 소리 및 입자 효과를 추가",
	"action.timeline_focus": "필터 채널",
	"action.timeline_focus.desc": "타임라인에 표시할 애니메이션 채널 선택",
	"timeline.particle": "입자",
	"timeline.sound": "소리",
	"timeline.effects": "효과",
	"data.format": "형식",
	"format.optifine_part": "OptiFine 부위",
	"format.optifine_part.desc": "OptiFine 엔티티 모델을 위한 JPM 부위",
	"action.reverse_keyframes": "키프레임 반전",
	"action.reverse_keyframes.desc": "선택된 키프레임들의 순서를 반전시킵니다",
	"generic.help": "도움말",
	"message.removed_faces": "%0개의 면이 제거되었습니다",
	"dialog.sketchfab_uploader.draft": "초안",
	"action.slider_pos": "%0축 이동",
	"action.slider_pos.desc": "%0축을 기준으로 큐브 이동",
	"action.slider_size": "%0축 크기",
	"action.slider_size.desc": "%0축을 기준으로 큐브 크기 조정",
	"action.slider_rotation": "%0 회전",
	"action.slider_rotation.desc": "%0축을 기준으로 큐브 회전",
	"action.slider_origin": "%0축 회전 중심",
	"action.slider_origin.desc": "회전 중심을 %0축을 기준으로 이동",
	"action.rotate_cw": "+90도만큼 %0 회전",
	"action.rotate_cw.desc": "%0축을 기준으로 큐브 90° 회전",
	"action.rotate_ccw": "-90도만큼 %0 회전",
	"action.rotate_ccw.desc": "선택한 큐브를 %0 축에서 -90° 회전",
	"action.flip": "%0 뒤집기",
	"action.flip.desc": "%0 축을 중심으로 선택된 큐브 뒤집기",
	"action.center": "%0축 중심",
	"action.center.desc": "선택된 큐브를 %0 축의 중심으로 이동",
	"action.bring_up_all_animations": "모든 애니메이션 가져오기",
	"panel.bone": "뼈대",
	"data.color": "색상",
	"generic.export": "내보내기",
	"generic.none": "없음",
	"status_bar.recording": "타임랩스 기록",
	"message.add_to_palette": "팔레트에 추가",
	"message.size_modifiers": "Ctrl 또는 Shift를 유지하여 더 작은 증분으로 변환",
	"message.timelapse_start": "타임랩스 시작됨",
	"message.timelapse_stop": "타임랩스 멈춤",
	"message.import_palette.replace_palette": "오래된 팔레트 바꾸기",
	"message.import_palette.threshold": "병합 임계값",
	"dialog.timelapse.interval": "간격 (초)",
	"dialog.timelapse.source": "출처",
	"dialog.timelapse.source.interface": "인터페이스",
	"dialog.timelapse.source.locked": "각도 고정",
	"dialog.timelapse.destination": "목적지 폴더",
	"layout.color.checkerboard": "체커보드",
	"layout.color.checkerboard.desc": "캔버스와 UV 편집기의 배경",
	"layout.font.code": "폰트 코드",
	"layout.css": "커스텀 CSS",
	"settings.category.paint": "칠하기",
	"settings.deactivate_size_limit": "크기 제한 비활성화",
	"settings.deactivate_size_limit.desc": "특정 모델의 크기 제한을 제거합니다. ( 경고 : 이 설정은 오류를 발생시킬 수 있습니다! )",
	"settings.brush_opacity_modifier": "불투명 브러시 수정",
	"settings.brush_opacity_modifier.desc": "스타일러스펜을 사용할 때 브러시 투명도 설정",
	"settings.brush_size_modifier": "브러시 크기 조정",
	"settings.brush_size_modifier.desc": "스타일러스펜을 사용할 때 브러시 크기 설정",
	"settings.brush_modifier.pressure": "압력",
	"settings.brush_modifier.tilt": "기울기",
	"category.color": "색상",
	"action.import_theme": "테마 불러오기",
	"action.export_theme": "테마 내보내기",
	"action.export_theme.desc": "현재 설정을 백업 파일로 생성",
	"action.slider_color_h": "합성 색",
	"action.slider_color_s": "채도",
	"action.slider_color_v": "값",
	"action.add_to_palette": "팔레트에 추가",
	"action.add_to_palette.desc": "선택된 색깔을 팔레트에 추가",
	"action.import_palette": "팔레트 불러오기",
	"action.import_palette.desc": "팔레트 파일 불러오기",
	"action.export_palette": "팔레트 내보내기",
	"action.export_palette.desc": ".GPL 파일로 색상 견본 내보내기",
	"action.generate_palette": "팔레트 생성...",
	"action.generate_palette.desc": "텍스쳐로부터 팔레트 생성",
	"action.sort_palette": "팔레트 정렬",
	"action.sort_palette.desc": "팔레트의 모든 색깔을 색깔과 밝기로 정렬",
	"action.timelapse": "타임랩스",
	"action.timelapse.desc": "모델 제작의 진행 등의 모든 행동들을 기록합니다.",
	"action.add_keyframe": "키프레임 추가",
	"action.add_keyframe.desc": "자동으로 키 프레임을 추가합니다. 쉬프트를 눌러 강제로 기본 값으로 합니다.",
	"action.bring_up_all_animations.desc": "설정된 모든 애니메이션들을 타임라인으로 불러옵니다.",
	"timeline.timeline": "지시",
	"menu.palette.load.default": "기본값",
	"generic.import": "불러오기",
	"settings.brush_modifier.none": "없음",
	"action.export_entity": "베드락 엔티티 내보내기",
	"action.export_entity.desc": "현재 제작되어있는 모델을 엔티티 모델 (mobs.json) 로 저장",
	"settings.highlight_cubes": "큐브 강조하기",
	"settings.highlight_cubes.desc": "큐브를 마우스로 가리킬 시 혹은 선택할 시 강조하기",
	"action.add_marker": "마커 설정",
	"action.add_marker.desc": "타임라인 표시하기",
	"timeline.pre_effect_script": "스크립트",
	"format.skin": "마인크래프트 스킨",
	"format.skin.desc": "플레이어, 엔티티 스킨 수정",
	"message.sketchfab.setup_guide": "Sketchfab 에서 3D 모델을 제작하는 방법은 %0 을(를) 참고하세요.",
	"dialog.skin.title": "마인크래프트 스킨 생성",
	"dialog.skin.model": "스킨 모델",
	"action.toggle_skin_layer": "스킨 레이어 스위치",
	"action.toggle_skin_layer.desc": "스킨 모델의 모자와 옷 등의 레이어를 활성화 혹은 비활성화",
	"action.gui_light": "GUI 밝기",
	"action.gui_light.desc": "아이템이 인벤토리에서 밝혀지는 방법 선택",
	"action.gui_light.side": "옆면 빛",
	"action.gui_light.front": "앞면 빛",
	"action.move_keyframe_back": "키 프레임을 뒤로 옮기기",
	"action.move_keyframe_forth": "키 프레임을 앞으로 이동",
	"menu.help": "도움",
	"menu.help.discord": "디스코드 서버",
	"menu.help.report_issue": "문제 신고",
	"menu.help.plugin_documentation": "플러그인 API 문서",
	"menu.help.search_action": "검색 후 실행 동작",
	"menu.help.donate": "기부",
	"menu.help.about": "더보기",
	"menu.preview.background.clipboard": "클립보드에서 불러오기",
	"dialog.ignore": "무시",
	"generic.unset": "설정 안함",
	"message.invalid_builtin_parent.title": "잘못된 페런트입니다.",
	"message.invalid_builtin_parent.message": "잘못된 페런트 '%0' 의 링크가 모델을 저장하기 위하여 삭제되었습니다.",
	"dialog.resize_texture.fill": "채우기",
	"dialog.resize_texture.fill.transparent": "투명",
	"dialog.resize_texture.fill.color": "색상",
	"dialog.resize_texture.fill.repeat": "반복",
	"dialog.scale.element_pivot": "요소 중심점",
	"dialog.scale.selection_center": "중심 선택",
	"dialog.create_gif.length_mode": "길이 설정",
	"dialog.create_gif.length_mode.seconds": "초",
	"dialog.create_gif.length_mode.frames": "프레임",
	"dialog.create_gif.length_mode.animation": "애니메이션 길이",
	"dialog.create_gif.length_mode.turntable": "회전가능한 회선",
	"dialog.save_angle.projection": "빛 관통",
	"dialog.save_angle.projection.perspective": "원근법",
	"dialog.save_angle.projection.orthographic": "직교",
	"dialog.sketchfab_uploader.animations": "애니메이션",
	"dialog.settings.theme": "테마",
	"settings.category.interface": "인터페이스",
	"settings.preview_checkerboard": "체커보드 프리뷰",
	"settings.preview_checkerboard.desc": "미리보기 뒤에 있는 체크보드 배경 전환",
	"settings.uv_checkerboard": "UV 에디터 체커보드",
	"settings.uv_checkerboard.desc": "UV 에디터 뒤에 있는 체크보드 배경 전환",
	"category.paint": "칠하기",
	"action.fill_mode.color_connected": "연결된 색상들",
	"action.draw_shape_type": "모양 타입",
	"action.draw_shape_type.rectangle": "직사각형",
	"action.draw_shape_type.rectangle_h": "직사각형 (할로우)",
	"action.draw_shape_type.ellipse": "타원형",
	"action.draw_shape_type.ellipse_h": "타원형 (할로우)",
	"action.draw_shape_type.line": "선",
	"action.mirror_painting": "좌우반전 칠하기",
	"action.mirror_painting.description": "페인트 스트로크를 모델의 다른 쪽으로 반전합니다",
	"action.lock_alpha": "알파 채널 잠그기",
	"action.lock_alpha.description": "모든 픽셀의 투명성을 잠그기",
	"action.draw_shape_tool": "모양 그리기",
	"action.draw_shape_tool.desc": "텍스쳐에 간단한 모양을 그리는 도구",
	"action.export_gltf": "glTF 모델로 내보내기",
	"action.export_gltf.desc": "모델과 애니메이션을 공유와 렌더링을 위한 glTF 파일로 내보내기",
	"action.transform_space": "공간 바꾸기",
	"action.transform_space.desc": "큐브 및 뼈대의 기본 변환 공간",
	"action.transform_space.global": "글로벌",
	"action.transform_space.local": "로컬",
	"action.toggle_camera_projection": "카메라 투사 토글",
	"action.toggle_camera_projection.desc": "원근법과 직교법 사이에 카메라 투영 전환",
	"action.load_camera_angle": "카메라 각도: %0",
	"action.load_camera_angle.desc": "카메라 각도 불러오기 '%0'",
	"action.slider_face_tint": "옅은 색 색인",
	"action.slider_face_tint.desc": "현재 면의 색인 지수를 설정합니다. -1은 설정 해제를 의미합니다.",
	"menu.help.quickstart": "빠른시작 마법사",
	"menu.help.developer": "개발진",
	"menu.help.developer.dev_tools": "개발 도구 열기",
	"menu.help.developer.reset_storage": "공장 초기화",
	"menu.help.developer.reset_storage.confirm": "Blockbench를 공장초기화 하시겠습니까? 모든 커스텀 설정과 키 바인딩, 설치된 플러그인들이 지워질것입니다",
	"menu.help.developer.cache_reload": "캐쉬 리로드",
	"menu.preview.orthographic": "정사영",
	"menu.preview.save_angle": "각도 저장...",
	"menu.preview.angle": "각도",
	"menu.preview.angle.initial": "첫 각도",
	"menu.preview.maximize": "최대치",
	"uv_editor.copy_selection": "선택 항목 복사",
	"uv_editor.paste_selection": "선택 항목 붙여넣기",
	"uv_editor.copy_paste_tool.place": "확인",
	"uv_editor.copy_paste_tool.mirror_x": "X축으로 좌우반전",
	"uv_editor.copy_paste_tool.mirror_y": "Y축으로 좌우반전",
	"uv_editor.copy_paste_tool.rotate": "90도 회전",
	"dialog.project.modded_entity_version": "저장될 버전",
	"dialog.save_angle.position": "카메라 위치",
	"dialog.save_angle.target": "초점",
	"dialog.skin.pose": "포즈",
	"layout.color.frame": "프레임",
	"layout.color.frame.desc": "경계와 제목",
	"settings.large_grid_size": "블록 격자 크기",
	"settings.large_grid_size.desc": "블록 격자의 크기",
	"action.load_plugin_from_url": "URL로부터 플러그인을 불러옵니다.",
	"action.load_plugin_from_url.desc": "지정된 URL의 서버로부터 플러그인을 불러옴",
	"action.cube_counter.desc": "큐브의 현재 갯수와 다른 통계를 표시함",
	"action.unlock_everything": "모두 잠금 해제",
	"action.unlock_everything.desc": "바깥쪽의 요소 잠금 해제",
	"action.load_palette": "팔레트 불러오기",
	"action.load_palette.desc": "사전에 설정된 팔레트 설정 불러오기",
	"action.toggle_locked": "잠금 여부 설정",
	"action.toggle_locked.desc": "선택한 요소의 잠금 여부를 전환함",
	"action.apply_display_preset": "기본 설정 적용하기",
	"action.apply_display_preset.desc": "기본 설정 혹은 커스텀 설정 적용하기",
	"action.apply_display_preset.here": "해당 슬릇에 적용하기",
	"action.apply_display_preset.everywhere": "모든 슬릇에 적용하기",
	"action.resolve_keyframe_expressions": "키 프레임 재설정",
	"action.resolve_keyframe_expressions.desc": "설정된 키 프레임의 수학 값을 재설정함",
	"action.fold_all_animations": "모든 애니메이션 접기",
	"menu.palette.load.empty": "공백",
	"switches.lock": "잠금",
	"settings.render_sides": "옆면 렌더",
	"settings.render_sides.desc": "어느 면이 렌더될지 선택",
	"settings.render_sides.auto": "자동",
	"settings.render_sides.front": "바깥",
	"settings.render_sides.double": "안쪽과 바깥",
	"generic.enable": "허용",
	"generic.disable": "비허용",
	"generic.redacted": "재조정됨",
	"dialog.select_texture.import_all": "모두 불러오기",
	"dialog.skin.layer_template": "레이어 텍스쳐",
	"about.version.up_to_date": "최신 정보",
	"about.version.update_available": "%0 버전을 사용할 수 있습니다",
	"settings.category.application": "애플리케이션",
	"settings.streamer_mode": "스트리머 모드",
	"settings.streamer_mode.desc": "최근 모델과 같은 민감한 정보 숨기기",
	"settings.automatic_updates": "자동 업데이트",
	"settings.automatic_updates.desc": "BlockBench의 최신 정보와 버전을 자동으로 다운로드",
	"action.rotation_space": "회전 공백",
	"action.focus_on_selection": "선택 중심 보기",
	"action.focus_on_selection.desc": "현재 선택 중심으로 카메라 정렬",
	"action.jump_to_timeline_start": "애니메이션 시작 지점으로",
	"action.jump_to_timeline_end": "애니메이션 마침 지점으로",
	"menu.help.updating": "업데이트 중.. (%0%)",
	"menu.help.update_failed": "업데이트 실패",
	"menu.animation.loop.once": "한 번 실행",
	"menu.animation.loop.hold": "마지막 프레임 유지",
	"menu.animation.loop.loop": "루프",
	"interface.streamer_mode_on": "스트리머 모드 허용",
	"generic.reset": "초기화",
	"generic.restore": "복구",
	"keys.mousewheel": "마우스 휠",
	"message.delete_animation.title": "애니메이션 삭제",
	"message.delete_animation.message": "애니메이션이 Blockbench에서 제거되었습니다. 저장된 애니메이션 파일도 제거하시겠습니까?",
	"message.no_animation_to_import": "불러올 애니메이션이 존재하지 않습니다.",
	"dialog.material_instances.title": "머티리얼 인스턴스",
	"dialog.animation_import.title": "불러올 애니메이션 선택",
	"dialog.create_texture.padding": "내부 여백",
	"settings.fov": "시야각",
	"settings.fov.desc": "카메라 시야각. 기본값 45.",
	"settings.minify_bbmodel": "압축된 프로젝트 파일",
	"settings.minify_bbmodel.desc": ".bbmodel 파일을 한 줄에 압축하기",
	"action.edit_material_instances": "머티리얼 인스턴스 편집",
	"action.edit_material_instances.desc": "베드락 블록 지오메트리를 위한 머티리얼 인스턴스 이름 수정",
	"action.save_all_animations": "애니메이션 모두 저장",
	"action.save_all_animations.desc": "현재 로드 된 애니메이션 모두 저장",
	"action.keyframe_interpolation": "보간",
	"action.keyframe_interpolation.desc": "키프레임 보간 모드 선택",
	"action.keyframe_interpolation.linear": "선형",
	"action.keyframe_interpolation.catmullrom": "부드러움",
	"action.timeline_focus.hide_empty": "빈 채널 숨기기",
	"menu.file.preferences": "사용자 설정",
	"menu.animation.blend_weight": "혼합 중량",
	"menu.animation.save": "저장",
	"menu.animation.properties": "속성...",
	"menu.animation.file": "파일",
	"menu.animation.snapping": "스냅",
	"menu.animation.open_location": "파일 위치 열기",
	"panel.keyframe.add_data_point": "키스페림 데이터 포인트 추가",
	"panel.keyframe.remove_data_point": "데이터 포인트 삭제",
	"panel.keyframe.pre": "프리",
	"panel.keyframe.post": "게시",
	"generic.all": "모두",
	"message.small_face_dimensions.title": "호환되지 않는 면",
	"message.small_face_dimensions.message": "선택사항에 한 방향으로 1 유닛보다 작은 표면이 포함되어 있습니다. 상자 UV 매핑 시스템은 해당 임계값 이하의 면을 0 픽셀 폭으로 간주합니다. 따라서 그 표면의 질감은 올바르게 작동하지 않을 수 있습니다.",
	"message.small_face_dimensions.face_uv": "현재 포맷은 작은 표면 치수를 처리할 수 있는 표면별 UV 맵을 지원합니다. \"파일\" > \"프로젝트...\" 로 가서 \"UV 모드\"를 \"표면별 UV\"로 바꿀 수 있습니다.",
	"dialog.plugins.outdated_client": "Blockbench를 새 버전으로 업데이트 해야 합니다",
	"dialog.plugins.outdated_plugin": "플러그인이 구 버전이며 현재 Blockbench 버전에서 작동하지 않습니다",
	"settings.motion_trails": "모션 트레일",
	"settings.motion_trails.desc": "에니메이션 편집기에서 모션 트레일을 표시하기",
	"settings.antialiasing": "안티에일리어싱",
	"settings.antialiasing.desc": "미리보기에서 안티에일리어싱 토글하기. Blockbench 를 재시작하여 변경사항을 적용하세요.",
	"action.timeline_frame_back": "1 프레임 뒤로 보내기",
	"action.timeline_frame_forth": "1 프레임 앞으로 보내기",
	"panel.bone.ik": "Inverse Kinematics (실험적 기능)",
	"settings.particle_tick_rate": "파티클 틱 레이트",
	"settings.particle_tick_rate.desc": "초당 틱의 파티클 효과에 대한 틱 레이트. 기본값 30",
	"action.lock_motion_trail": "모션 트레일 잠굼",
	"action.lock_motion_trail.desc": "현재 선택된 그룹의 모션 트레일 잠구기",
	"menu.animation_file.unload": "에니메이션 파일 언로드",
	"data.null_object": "빈 객체",
	"status_bar.toggle_sidebar": "사이드바 토글하기",
	"message.load_plugin_failed.title": "플러그인을 불러오는데 실패했습니다",
	"message.load_plugin_failed.message": "플러그인의 기본 파일 이름이 Plugin.register()에 정의된 플러그인 ID '%0'과 일치하는지 확인하십시오",
	"dialog.project.uv_mode": "UV 모드",
	"dialog.project.uv_mode.box_uv": "상자 UV",
	"dialog.project.uv_mode.face_uv": "표면별 UV",
	"dialog.project.texture_size": "텍스쳐 크기",
	"dialog.animation_export.title": "내보낼 애니메이션을 선택하세요",
	"dialog.create_texture.rearrange_uv": "재정렬 UV",
	"layout.color.subtle_text": "세밀 텍스트",
	"layout.color.subtle_text.desc": "대조도가 낮은 이차 텍스트 색상",
	"settings.interface_scale": "인터페이스 크기",
	"settings.interface_scale.desc": "전체 Blockbench 인터페이스 크기",
	"settings.background_rendering": "배경 랜더링",
	"settings.background_rendering.desc": "창이 선택되지 않은 동안에 프리뷰 업데이트",
	"settings.ctrl_shift_size": "Control + Shift 해상도",
	"settings.ctrl_shift_size.desc": "Control과 Shift를 누르는 동안 격자의 해상도 조정",
	"settings.hardware_acceleration": "하드웨어 가속",
	"settings.hardware_acceleration.desc": "그래픽 카드에 렌더링 작업을 아웃소싱합니다. 변경사항을 적용하려면 Blockbench를 다시 시작하십시오.",
	"action.explode_skin_model": "스킨 모델 파괴",
	"action.explode_skin_model.desc": "덮인 표면을 편집할 수 있는 폭발 뷰 전환",
	"action.export_minecraft_skin": "마인크래프트 스킨 내보내기",
	"action.export_minecraft_skin.desc": "마인크래프트 스킨 PNG로 내보내기",
	"action.add_null_object": "빈 객체 추가",
	"action.add_null_object.desc": "새 빈 객체를 추가합니다",
	"action.animated_texture_frame": "애니메이션 택스쳐 프레임",
	"action.animated_texture_frame.desc": "에니메이션 택스쳐의 현재 프레임 설정하기",
	"action.export_animation_file": "애니메이션 내보내기...",
	"action.export_animation_file.desc": "선택된 에니메이션들을 새로운 파일로 내보내기",
	"action.timeline_graph_editor": "그래프 편집기 토글하기",
	"action.timeline_graph_editor.desc": "그래프 편집기 뷰와 키프레임 뷰 사이의 타임라인 전환",
	"menu.file.recent.clear": "최근 사용된 파일 기록 삭제",
	"switches.shade": "그림자",
	"generic.share": "공유",
	"dates.minute": "%0분",
	"dates.minutes": "%0분",
	"dates.hour": "%0시간",
	"dates.hours": "%0시간",
	"dates.day": "%0일",
	"dates.days": "%0일",
	"dates.week": "%0주",
	"dates.weeks": "%0주",
	"dates.year": "%0년",
	"dates.years": "%0년",
	"message.installed_plugin": "%0 플러그인을 성공적으로 설치했습니다",
	"message.installed_plugin_fail": "%0 플러그인을 설치하는 데 실패했습니다",
	"dialog.share_model.title": "모델 공유하기",
	"dialog.share_model.expire_time": "만료 시간",
	"dialog.share_model.failed": "모델을 업로드하는 데 실패했습니다",
	"action.import_java_block_model": "Java 블록/아이템 모델 추가",
	"action.import_java_block_model.desc": "현재 모델에 json 파일로 부터 Minecraft Java 의 블록/아이템을 추가",
	"action.share_model": "공유하기...",
	"action.share_model.desc": "모델 공유 링크 생성",
	"action.import_project": "프로젝트 불러오기",
	"action.import_project.desc": ".bbmodel 파일에서 다른 프로젝트를 현재 프로젝트로 가져오기",
	"dialog.toolbar_edit.hidden_tools": "일부 도구는 현재 모드, 형식 또는 상황에서 사용할 수 없기 때문에 숨겨질 수 있습니다.",
	"settings.camera_near_plane": "카메라 근방 평면",
	"settings.camera_near_plane.desc": "객체가 렌더링되는 카메라에서 최소 거리입니다. 값이 높을수록 Z-파이팅이 감소합니다. 기본값은 1입니다.",
	"mode.start.keymap_preference.desc": "Blockbench에 처음 온 사람이고 다른 3D 프로그램에서 온 사람이라면 키맵핑을 선택하여 전환을 쉽게 할 수 있습니다. 나중에 설정에서 키맵핑 또는 개별 키바인딩을 변경할 수 있습니다.",
	"message.load_keymap": "이 키 설정을 불러오시겠습니까? 현재 키 설정을 덮어쓰게 됩니다.",
	"message.keymap_loaded": "키맵핑 로드됨",
	"dialog.convert_project.current_format": "현재 포맷",
	"dialog.create_texture.rearrange_uv.desc": "새로운 UV 배열을 만들어 모든 표면에 질감에 대한 자체 지점을 생성",
	"dialog.create_texture.power.desc": "자동 텍스쳐 크기를 64 또는 128과 같은 2의 거듭제곱으로 잠금. 일부 렌더러가 요구됨",
	"dialog.create_texture.double_use.desc": "두 요소가 이미 동일한 UV 공간을 할당한 경우 새 맵에 그대로 유지",
	"dialog.create_texture.padding.desc": "템플릿의 개별 부위 사이에 작은 여백을 추가",
	"dialog.create_texture.resolution.desc": "텍스쳐의 높이 및 폭",
	"dialog.create_gif.color": "배경 색",
	"dialog.save_angle.zoom": "확대하기",
	"dialog.skin.variant": "변형",
	"dialog.flip_animation.info": "반대 뼈는 이름 안에 '왼쪽'과 '오른쪽'이라는 키워드로 식별됩니다.",
	"dialog.export_private_settings.title": "개인 설정",
	"dialog.export_private_settings.message": "파일에 다음 개인 정보가 포함되어 있습니다 : **%0**. 파일을 다른 사람과 공유할 경우 이 값을 제외하십시오.",
	"dialog.export_private_settings.keep": "유지",
	"settings.timecode_frame_number": "프레임 숫자의 타임코드 표시",
	"settings.timecode_frame_number.desc": "타임라인에 타임코드 부분을 센티세컨드 대신 프레임 숫자로 표시",
	"settings.animation_sample_rate": "애니메이션 샘플 레이트",
	"settings.animation_sample_rate.desc": "각 포맷이 기본적으로 지원하지 않는 곡선에 대해 초당 샘플 비율",
	"keybind.preview_zoom": "확대 보기",
	"action.gradient_tool": "그라데이션 도구",
	"action.gradient_tool.desc": "텍스쳐에 그라데이션 색상 생성",
	"action.import_settings": "설정 불러오기",
	"action.import_settings.desc": ".bbsettings 파일 내보내기",
	"action.export_settings": "설정 내보내기",
	"action.export_settings.desc": ".bbsettings 파일로 Blockbench 설정 내보내기",
	"action.load_keymap": "키맵핑 불러오기",
	"action.load_keymap.default": "기본 (트랙패드/마우스)",
	"action.load_keymap.mouse": "기본 (마우스)",
	"action.load_keymap.default.desc": "노트북 트랙패드에서 사용하기 위해 최적화된 뷰포트 탐색 컨트롤이 있는 기본 Blockbench 키 바인딩",
	"action.load_keymap.mouse.desc": "뷰포트 탐색이 가운데 마우스 버튼에 바인딩된 기본 Blockbench 키 바인딩",
	"action.load_keymap.blender.desc": "Blender의 조작에 익숙한 유저들을 위한 조작키",
	"action.load_keymap.cinema4d.desc": "Cinema 4D의 조작에 익숙한 유저들을 위한 조작키",
	"action.load_keymap.maya.desc": "Autodesk Maya의 조작에 익숙한 유저들을 위한 조작키",
	"action.import_keymap": "키맵핑 불러오기",
	"action.import_keymap.desc": ".bbkeymap 파일로 키 설정 불러오기",
	"action.export_keymap": "키맵핑 내보내기",
	"action.export_keymap.desc": "현재 키바인딩을 .bbkeymap 파일로 내보내기",
	"action.edit_history": "히스토리 수정...",
	"action.edit_history.desc": "수정 히스토리와 실행 취소 또는 되돌리기 단계 보기",
	"action.group_elements": "그룹 요소",
	"action.group_elements.desc": "선택된 요소를 새 그룹으로 모으기",
	"action.unfold_groups": "그룹 펼치기",
	"action.unfold_groups.desc": "개요의 모든 그룹 접기",
	"action.edit_bedrock_binding": "키 편집...",
	"action.edit_bedrock_binding.desc": "지오메트리가 바운드된 뼈대 변경",
	"action.pick_screen_color": "화면 색상 선택",
	"action.pick_screen_color.desc": "화면에 있는 색상 선택",
	"action.view_mode": "뷰 모드",
	"action.view_mode.desc": "모델 보기 모드 전환",
	"action.view_mode.textured": "택스쳐 적용",
	"action.view_mode.solid": "택스쳐 비적용",
	"action.view_mode.wireframe": "\n",
	"action.toggle_sidebars": "사이드바 전환",
	"action.toggle_sidebars.desc": "사이드바 활성화 또는 비활성화",
	"action.set_animation_end": "애니메이션 끝 설정",
	"action.set_animation_end.desc": "선택한 애니메이션의 끝을 현재 타임라인 시간으로 설정",
	"action.flip_animation": "뒤집기 애니메이션",
	"action.flip_animation.desc": "선택한 키프레임을 모델의 다른 면에 복사하여 애니메이션의 일부를 뒤집음",
	"action.graph_editor_zero_line": "제로 라인 포함",
	"action.graph_editor_zero_line.desc": "그래프 편집기가 항상 뷰에 제로 라인을 포함하는지 여부",
	"menu.texture.render_mode": "렌더 모드",
	"menu.texture.render_mode.emissive": "방출",
	"menu.texture.render_mode.layered": "레이어드",
	"menu.preview.angle.edit": "각도 편집",
	"menu.animation.start_delay": "시작 딜레이",
	"menu.animation.loop_delay": "루프 딜레이",
	"menu.animation.flip_keyframes": "키프레임 뒤집기",
	"menu.mobile_keyboard.disable_all": "모두 비활성화",
	"panel.keyframe.toggle_uniform_scale": "유니폼 크기 전환",
	"camera_angle.common_isometric_right": "아이소메트릭 오른쪽 (2:1)",
	"camera_angle.common_isometric_left": "아이소메트릭 왼쪽 (2:1)",
	"camera_angle.true_isometric_right": "트루 아이소메트릭 오른쪽 (30°)",
	"camera_angle.true_isometric_left": "트루 아이소메트릭 왼쪽 (30°)",
	"menu.help.wiki": "Blockbench 위키",
	"settings.update_to_prereleases": "사전 릴리즈로 업데이트",
	"settings.update_to_prereleases.desc": "새로운 기능을 테스트하기 위해 블록벤치 베타 버전을 자동으로 업데이트합니다. 사전 릴리스 버전은 불안정할 수 있으며, 작업 또는 기타 중요한 프로젝트에 대해 Blockbench에 의존할 경우 이 옵션을 사용하지 마십시오.",
	"data.separator.spacer": "스페이서",
	"data.separator.linebreak": "라인 브레이크",
	"data.setting": "설정",
	"generic.select_all": "모두 선택",
	"generic.select_none": "선택 해제",
	"projects.new_tab": "새로운 탭",
	"projects.close_tab": "탭 닫기",
	"message.invalid_format.title": "유효하지 않은 포맷",
	"message.invalid_format.message": "이 모델은 Blockbench 설치에서 사용할 수 없는 '%0' 포맷으로 만들어졌습니다. 정상적으로 열기 위해서는 특정 플러그인이 필요합니다.",
	"message.invalid_link": "유효하지 않거나 만료된 모델 링크",
	"message.default_textures.current": "현재 위치",
	"message.update_after_restart": "이 업데이트는 다음 재시작 후에 설치됩니다",
	"message.copy_paste_tool_viewport": "이 도구는 UV 패널에서만 사용할 수 있습니다",
	"dialog.project.shadow_size": "그림자 크기",
	"dialog.find_replace.target": "대상",
	"dialog.find_replace.target.element_names": "요소 이름",
	"dialog.find_replace.target.group_names": "그룹 이름",
	"dialog.find_replace.target.animation_names": "애니메이션 이름",
	"dialog.find_replace.target.keyframe_values": "키프레임 값",
	"dialog.find_replace.find": "찾기",
	"dialog.find_replace.replace": "교체",
	"dialog.find_replace.regex": "규칙적 표현",
	"dialog.add_primitive.shape": "모양",
	"dialog.add_primitive.shape.circle": "원",
	"dialog.add_primitive.shape.tube": "튜브",
	"dialog.add_primitive.shape.cone": "원뿔",
	"dialog.add_primitive.shape.cylinder": "원기둥",
	"dialog.add_primitive.shape.sphere": "구",
	"dialog.add_primitive.shape.torus": "원환면",
	"dialog.add_primitive.shape.cube": "큐브",
	"dialog.add_primitive.shape.pyramid": "피라미드",
	"dialog.add_primitive.diameter": "지름",
	"dialog.add_primitive.height": "높이",
	"dialog.add_primitive.sides": "옆면",
	"dialog.add_primitive.minor_diameter": "굵기",
	"dialog.add_primitive.minor_sides": "주요 옆면",
	"dialog.create_texture.combine_polys": "표면 결합",
	"dialog.create_texture.combine_polys.desc": "연결된 평면 면을 하나의 UV 섹션에 결합함",
	"dialog.model_stats.meshes": "메쉬들",
	"dialog.export_private_settings.omit": "떠나기",
	"layout.select": "선택",
	"layout.options": "설정",
	"layout.color": "색도",
	"layout.documentation": "문서",
	"layout.color.bright_ui_text": "밝은 UI 텍스트",
	"layout.color.bright_ui_text.desc": "밝은 배경에 텍스트",
	"layout.name": "이름",
	"layout.author": "제작자",
	"settings.dialog.desc": "\"%0\" 다이얼로그 표시",
	"settings.export_empty_groups": "비어있는 그룹 내보내기",
	"settings.export_empty_groups.desc": "내보낸 파일에 내용 없는 그룹을 포함함",
	"category.separators": "분리기",
	"keybind.preview_area_select": "영역 선택",
	"action.color_erase_mode": "지우기 모드",
	"action.color_erase_mode.desc": "지우기 모드가 활성화된 상태에서 채우기 및 직사각형과 같은 도구는 색상을 추가하지 않고 지움",
	"action.open_from_link": "링크에서 모델 열기...",
	"action.open_from_link.desc": "blckbn.ch URL에서 모델 열기",
	"action.import_obj": "OBJ 모델 불러오기",
	"action.import_obj.desc": "OBJ 모델에서 객체를 메쉬로 가져오기",
	"action.add_plugin": "플러그인 설치",
	"action.add_plugin.desc": "액션 컨트롤에서 플러그인 설치",
	"action.remove_plugin": "플러그인 제거",
	"action.remove_plugin.desc": "액션 컨트롤에서 플러그인 제거",
	"action.add_mesh": "메쉬 추가",
	"action.add_mesh.desc": "새로운 메쉬 추가",
	"action.add_texture_mesh": "텍스쳐 메쉬 추가",
	"action.add_texture_mesh.desc": "새로운 텍스쳐 메쉬 추가",
	"action.find_replace": "찾기/바꾸기...",
	"action.find_replace.desc": "이름의 부위를 찾고 바꾸기",
	"action.hide_everything_except_selection": "선택을 제외한 모든 것 숨기기",
	"action.hide_everything_except_selection.desc": "선택한 요소를 제외한 모든 요소에 대한 가시성을 전환함",
	"action.transform_space.normal": "일반",
	"action.selection_mode": "선택 모드",
	"action.selection_mode.desc": "뷰포트에서 요소를 선택하는 방법 변경",
	"action.selection_mode.object": "객체",
	"action.selection_mode.face": "표면",
	"action.selection_mode.vertex": "정점",
	"action.create_face": "표면이나 모서리 생성",
	"action.create_face.desc": "선택한 정점 사이에 새 표면 또는 모서리를 작성함",
	"action.convert_to_mesh": "메쉬로 변환",
	"action.convert_to_mesh.desc": "선택한 요소를 메쉬로 변환함",
	"action.invert_face": "표면 반전",
	"action.invert_face.desc": "선택한 면을 반전하여 반대 방향으로 향하게 함",
	"action.extrude_mesh_selection": "선택 압출",
	"action.extrude_mesh_selection.desc": "메쉬의 선택된 부분을 압출합니다",
	"action.loop_cut": "루프 자르기",
	"action.loop_cut.desc": "선택한 모서리를 가로지르는 루프에서 메쉬 분할함",
	"action.merge_meshes": "메쉬 병합",
	"action.merge_meshes.desc": "여러개의 메쉬를 하나로 병합",
	"action.keyframe_uniform": "유니폼 스케일링",
	"action.keyframe_uniform.desc": "선택된 키프레임에서 유니폼 스케일링 활성화",
	"menu.locator.ignore_inherited_scale": "상속된 크기 무시",
	"menu.texture.elements": "요소에 적용",
	"uv_editor.transparent_face": "투명한 표면",
	"display.pose_angle": "포즈 각도 (프리뷰 전용)",
	"data.mesh": "메쉬",
	"dialog.create_texture.type": "종류",
	"dialog.create_texture.type.blank": "공백",
	"dialog.create_texture.type.template": "텍스쳐 템플릿",
	"dialog.create_texture.type.color_map": "솔리드 컬러 템플릿",
	"dialog.sketchfab_uploader.suggested_tags": "제안된 태그",
	"dialog.sketchfab_uploader.category": "카테고리",
	"dialog.sketchfab_uploader.category2": "카테고리 2",
	"layout.restore_backup": "커스텀마이즈한 테마 \"%0\"가 덮어씌워졌습니다. 여기를 눌러 복원하십시오.",
	"layout.borders": "경계선",
	"action.fill_mode.element": "요소",
	"action.inset_mesh_selection": "인셋 삽입",
	"action.inset_mesh_selection.desc": "선택한 메쉬의 부위를 삽입합니다",
	"action.dissolve_edges": "모서리 분해",
	"action.dissolve_edges.desc": "선택한 모서리를 메쉬로 분해하고 분할한 면 병합",
	"action.split_mesh": "메쉬 분할",
	"action.split_mesh.desc": "메쉬의 선택된 면을 새 메쉬로 분할",
	"action.merge_vertices": "정점 병합",
	"action.merge_vertices.desc": "선택한 정점을 처음 선택한 정점의 위치에 병합",
	"action.view_mode.normal": "일반 표면",
	"action.snap_uv_to_pixels": "UV를 픽셀에 맞춤",
	"action.snap_uv_to_pixels.desc": "선택한 UV 정점을 픽셀 격자로 스냅",
	"menu.file.import.import_open_project": "열린 프로젝트 가져오기",
	"menu.help.unlock_projects": "모든 프로젝트 잠금 해제",
	"status_bar.selection.faces": "%0 표면",
	"status_bar.selection.vertices": "%0 정점",
	"message.merged_vertices": "%1 위치에서 %0 정점 발견 및 병합",
	"settings.vertex_merge_distance": "정점 병합 거리",
	"settings.vertex_merge_distance.desc": "거리별 병합을 사용하여 정점이 병합되는 거리",
	"settings.show_only_selected_uv": "선택된 UV만 표시",
	"settings.show_only_selected_uv.desc": "기본적으로 선택한 UV 면만 UV 편집기에 표시",
	"action.merge_vertices.merge_all": "모두 명합",
	"action.merge_vertices.merge_all_in_center": "모두 중앙에 병합",
	"action.merge_vertices.merge_by_distance": "거리에 따라 병합",
	"action.merge_vertices.merge_by_distance_in_center": "중앙에서의 거리에 따라 병합",
	"action.uv_rotate_left": "UV를 왼쪽으로 회전",
	"action.uv_rotate_left.desc": "선택한 UV 면을 시계 반대 방향으로 회전",
	"action.uv_rotate_right": "UV를 오른쪽으로 회전",
	"action.uv_rotate_right.desc": "선택한 UV 면을 시계 방향으로 회전",
	"menu.uv.display_uv": "UV 표시",
	"menu.uv.display_uv.selected_faces": "선택된 표면",
	"menu.uv.display_uv.selected_elements": "모든 표면",
	"menu.uv.display_uv.all_elements": "모든 요소의 모든 표면",
	"menu.paste.face": "UV 표면",
	"menu.paste.mesh_selection": "메쉬 선택",
	"menu.paste.outliner": "요소",
	"uv_editor.show_all_faces": "모든 표면 표시",
	"uv_editor.show_selected_faces": "선택된 표면 표시",
	"status_bar.selection.edges": "%0 모서리",
	"action.selection_mode.edge": "모서리",
	"message.cannot_re_import.title": "모델을 불러올 수 없습니다",
	"message.cannot_re_import.message": "모델 형식으로 내보내진 모델은 다시 Blockbench에서 불러올 수 없습니다. 모델을 프로젝트 파일로 저장해주세요.",
	"generic.default": "기본",
	"units.pixels_per_meter": "미터 당 %0 픽셀",
	"mode.pose": "포즈",
	"modifier_actions.resize_both_sides": "양 방향으로 크기 재조정",
	"modifier_actions.resize_one_side": "한 방향으로 크기 재조정",
	"modifier_actions.draw_line": "선 그리기",
	"modifier_actions.drag_without_snapping": "스내핑 없이 드래그",
	"modifier_actions.stretch_keyframes": "키프레임 늘이기",
	"modifier_actions.resize_background": "배경 크기 재조정",
	"modifier_actions.select_multiple": "다중 선택",
	"modifier_actions.select_range": "범위 선택",
	"modifier_actions.drag_to_duplicate": "드래그로 복사",
	"modifier_actions.uniform_scaling": "유니폼 스케일링",
	"modifier_actions.snap_direction": "방향 맞춤",
	"message.no_valid_elements": "가능한 요소가 선택되지 않았습니다...",
	"dialog.add_primitive.shape.plane": "면",
	"dialog.save_angle.rotation_mode": "회전 모드",
	"dialog.save_angle.rotation": "회전",
	"dialog.save_angle.fov": "시야각",
	"settings.hide_tab_bar": "탭 바 자동 숨기기",
	"settings.hide_tab_bar.desc": "오직 한 개의 탭이 열려있을 때 탭 바를 숨김",
	"settings.status_bar_modifier_keys": "상태바에서 수정자 키 제안",
	"settings.status_bar_modifier_keys.desc": "상태바에 컨텍스트 인식 제안된 수정자 키 표시",
	"settings.ground_plane": "바닥",
	"settings.ground_plane.desc": "작업 공간에 바닥을 표시합니다.",
	"settings.preview_paste_behavior": "기본 미리보기 붙여넣기 동작",
	"settings.preview_paste_behavior.desc": "편집 모드에서 미리보기에 무언가를 붙여넣을 때 동작을 선택하고 여러 옵션을 사용할 수 있음",
	"settings.preview_paste_behavior.always_ask": "항상 묻기",
	"action.new_window": "새 창",
	"action.new_window.desc": "새로운 Blockbench 창 열기",
	"action.export_collada": "Collada 모델 (dae) 내보내기",
	"action.export_collada.desc": "모델 및 애니메이션을 dae 파일로 내보내서 다른 3D 응용 프로그램에서 사용",
	"action.paint_mode_uv_overlay": "UV 오버레이",
	"action.paint_mode_uv_overlay.desc": "페인트 모드에서 UV 맵을 오버레이로 표시",
	"action.bake_animation_into_model": "애니메이션을 모델로 만들기",
	"action.bake_animation_into_model.desc": "현재 표시된 애니메이션 프레임을 모델로 만듭니다. 회전 및 위치만 적용하고 크기는 무시됩니다.",
	"action.keyframe_interpolation.step": "단계",
	"action.set_ik_target": "Set IK Target",
	"action.set_ik_target.desc": "Inverse Kinematics을 통해 이 null 객체로 이동해야 하는 대상 뼈대 선택",
	"menu.action_control.type.tab": "탭",
	"menu.action_control.type.angle": "카메라 각도",
	"menu.action_control.recent_in_streamer_mode": "확실합니까? 스트리머 모드가 활성화되었습니다",
	"menu.action_control.recent_in_streamer_mode.desc": "최근 모델의 미리 보기를 보시겠습니까?",
	"menu.tools": "도구",
	"menu.file.recent.more": "더 보기...",
	"menu.null_object.lock_ik_target_rotation": "IK 목표 각 고정",
	"menu.animation_file.import_remaining": "남은 에니메이션 가져오기",
	"edit.loop_cut.offset": "오프셋",
	"edit.extrude_mesh_selection.extend": "확장",
	"cube.color.pink": "분홍",
	"cube.color.silver": "회색",
	"dialog.plugins.offline": "인터넷 연결 없음",
	"dialog.create_texture.pixel_density": "픽셀 밀도",
	"dialog.create_texture.pixel_density.desc": "블록 너비 당 픽셀의 밀도입니다. 참조 : 텍스쳐 맵의 크기는 요소의 크기에도 영향을 받을 수 있습니다.",
	"panel.skin_pose": "자세",
	"panel.skin_pose.none": "없음",
	"panel.skin_pose.natural": "기본",
	"panel.skin_pose.walking": "걷기",
	"panel.skin_pose.crouching": "웅크리기",
	"panel.skin_pose.sitting": "앉기",
	"panel.skin_pose.jumping": "점프",
	"panel.skin_pose.aiming": "사격",
	"edit.loop_cut.direction": "방향",
	"data.texture_mesh": "텍스쳐 메쉬",
	"generic.left": "왼쪽",
	"generic.right": "오른쪽",
	"mode.start.quick_setup": "빠른 설정",
	"mode.start.keymap": "키맵핑",
	"mode.start.quick_setup.more_themes": "더보기...",
	"dialog.resize_texture.animation_frames": "애니메이션 프레임",
	"dialog.export_emission_map.title": "Emission 맵 내보내기",
	"dialog.export_emission_map.format": "포맷",
	"dialog.export_emission_map.format.luminance": "휘도",
	"dialog.export_emission_map.format.luminance_inverted": "휘도 반전됨",
	"dialog.export_emission_map.format.colors": "색",
	"dialog.export_emission_map.threshold": "투명도 임계값",
	"dialog.export_emission_map.round_up": "%0 x %1 까지 .라운드 업",
	"dialog.export_emission_map.flip_y": "Y축 뒤집기",
	"dialog.select.type": "요소 타입",
	"dialog.create_texture.max_edge_angle": "모서리 각도 임계값",
	"dialog.create_texture.max_edge_angle.desc": "두 면이 여전히 결합되는 최대 각도",
	"dialog.create_texture.max_island_angle": "표면 각도 임계값",
	"dialog.create_texture.max_island_angle.desc": "동일한 UV 표면에 결합할 수 있는 최대 각도",
	"settings.mobile_panel_side": "모바일 패널 측면",
	"settings.mobile_panel_side.desc": "수평 방향으로 Blockbench를 사용할 때 화면 패널의 어느 쪽이 표시되는지 선택",
	"settings.obj_face_export_mode": "OBJ 표면 내보내기 모드",
	"settings.obj_face_export_mode.desc": "OBJ 내보내기에서 모든 표면을 tris 또는 quads로 변환하려면 선택",
	"settings.obj_face_export_mode.both": "기본",
	"settings.obj_face_export_mode.tris": "Tris로 변환",
	"settings.obj_face_export_mode.quads": "Quads로 변환",
	"action.seam_tool": "잇기 도구",
	"action.seam_tool.desc": "메쉬 모서리에 UV 잇기를 정의하는 도구",
	"action.resolve_group": "그룹 재설정",
	"action.resolve_group.desc": "자식을 같은 위치에 유지하면서 그룹을 재설정합니다.",
	"action.move_to_group": "그룹으로 이동",
	"action.move_to_group.desc": "선택한 요소를 다른 외곽선 그룹으로 이동",
	"action.select_seam": "UV 잇기 선택",
	"action.select_seam.desc": "선택한 모서리에 대해 UV 잇기 모드 선택",
	"action.select_seam.auto": "자동",
	"action.select_seam.join": "합치기",
	"action.select_seam.divide": "나누기",
	"action.adjust_brightness_contrast": "밝기 & 대조 조절...",
	"action.adjust_brightness_contrast.desc": "선택된 텍스쳐의 밝기와 대조를 조절",
	"action.adjust_saturation_hue": "채도 & 색조 조절...",
	"action.adjust_saturation_hue.desc": "선택된 텍스쳐의 채도와 색조를 조절",
	"action.invert_colors": "색 반전",
	"action.invert_colors.desc": "선택된 텍스쳐의 모든 색을 반전",
	"action.adjust_curves": "곡선 조절...",
	"action.adjust_curves.desc": "선택된 텍스쳐의 밝기 곡선을 조절",
	"action.flip_texture_x": "수평으로 텍스쳐 뒤집기",
	"action.flip_texture_y": "수직으로 텍스쳐 뒤집기",
	"action.resize_texture": "텍스쳐 크기 조정...",
	"action.view_mode.uv": "UV 미리보기",
	"action.append_to_template": "요소를 템플릿에 추가...",
	"action.append_to_template.desc": "현재 선택한 요소를 텍스쳐 템플릿에 추가함",
	"action.move_texture_with_uv": "UV와 텍스쳐 이동",
	"action.move_texture_with_uv.desc": "UV 표면을 드래그할 때 표면의 텍스쳐를 이동합니다",
	"action.timeline_setups": "타임라인 설정",
	"action.save_timeline_setup": "타임라인 설정 저장...",
	"action.save_timeline_setup.desc": "현재 선택한 애니메이터 및 채널의 프리셋 저장",
	"menu.texture": "텍스쳐",
	"menu.texture.render_mode.default": "기본",
	"menu.texture.merge_onto_texture": "위의 텍스쳐와 병합",
	"menu.animation.unload": "언로드",
	"panel.timeline": "타임라인",
	"action.pan_tool": "팬 도구",
	"action.pan_tool.desc": "뷰포트와 텍스쳐 에디터를 찾는 도구",
	"mode.start.recent.favorite": "즐겨찾기로 표시",
	"mode.start.info": "정보",
	"mode.start.target": "대상",
	"mode.start.start": "시작",
	"mode.start.create_new": "새로운 모델 만들기",
	"mode.start.format.informations": "알면 좋은 것:",
	"mode.start.format.resources": "리소스:",
	"format.free.info.meshes": "이 형식에서는 큐브와 사용자 정의 모양의 메쉬를 사용하여 로우 폴리 모형을 제작할 수 있습니다.",
	"format.free.info.limitation": "Minecraft 같은 특별한 포맷이 필요한 게임에서는 모델이 로드될 수 없습니다.",
	"format.skin.info.skin": "이 포맷은 마인크래프트 스킨과 엔티티 텍스쳐를 만들기 위해 생겼습니다.",
	"format.skin.info.model": "이 모델은 수정할 수 없습니다. 이 모델을 수정하려면, 먼저 **파일** > **프로젝트 변환** 을 통해 다른 포맷으로 변환하세요.",
	"format.java_block.info.rotation": "회전이 요소당 22.5도 단계와 하나의 회전축으로 제한됨",
	"format.java_block.info.size": "이 모델은 3, 3, 3 블록의 크기로 제한되어있습니다. 하지만 보기 설정에서 아이템 모델을 더 크게 만들 수 있습니다",
	"format.java_block.info.animation": "이 형식은 바닐라 마인크래프트에서 애니메이션을 지원하지 않습니다. 모드를 만드는 경우 GeckoLib을 사용하여 모델을 애니메이션화할 수 있습니다. 그렇지 않은 경우 애니메이션을 만드는 유일한 방법은 명령어 또는 애니메이션 텍스처를 사용하여 모델을 전환하는 것입니다.",
	"format.bedrock.info.textures": "각각의 모델은 하나의 텍스쳐만 가질 수 있습니다",
	"format.bedrock_block": "베드락 블록",
	"format.bedrock_block.desc": "마인크래프트 베드락 에디션을 위한 블록 모델",
	"format.modded_entity.info.integer_size": "개별 큐브의 크기는 정수로 제한됩니다.",
	"format.modded_entity.info.format": "모델은 다른 모든 Blockbench 내보내기 형식과 같은 전용 데이터 구조 대신 Java 코드로 작성됩니다.",
	"format.optifine_entity.info.optifine_required": "OptiFine이 설치되지 않은 사용자에게는 모델이 보이지 않습니다.",
	"format.optifine_entity.info.pivots": "뼈대의 회전 중심은 잠겨있으니, 손대지 않는 것이 좋겠네요.",
	"format_category.low_poly": "로우 폴리",
	"format_category.minecraft": "마인크래프트",
	"format_category.other": "그 외",
	"format_category.loaders": "로더",
	"message.recover_backup.recover": "복구",
	"message.invalid_characters.title": "유효하지 않은 경로",
	"message.invalid_characters.message": "가져온 파일의 경로가 유효하지 않은 문자, 대문자, 또는 띄어쓰기를 포함하고 있습니다. 지원되는 문자: %0",
	"dialog.share_model.thumbnail": "썸네일",
	"dialog.skin.high_res_texture": "선택한 해상도의 스킨은 일반 마인크래프트 스킨으로 사용할 수 없습니다. 더 낮은 해상도를 선택하세요.",
	"settings.allow_display_slot_mirror": "디스플레이 슬롯 미러링 허용",
	"settings.allow_display_slot_mirror.desc": "Java 아이템 모델의 디스플레이 슬롯을 미러링할 수 있습니다. 경고: 이것은 Minecraft 1.14 이전 버전 또는 특별한 경우에만 작동합니다.",
	"action.switch_tabs": "탭 전환",
	"action.switch_tabs.desc": "열려있는 탭들로 이동합니다. Shift를 눌러 반대 방향으로 이동할 수 있음",
	"action.unselect_all": "모두 선택 해제",
	"action.save_palette": "팔레트 저장...",
	"action.save_palette.desc": "현재 색상 팔레트를 나중에 사용하기 위해 Blockbench에 저장",
	"action.keyframe_column_create": "키프레임 열 생성",
	"action.keyframe_column_create.desc": "키프레임이 이미 있는 경우, 현재 타임코드에서 타임라인의 모든 채널을 키",
	"action.keyframe_column_select": "키프레임 열 선택",
	"action.keyframe_column_select.desc": "플레이헤드 아래의 열을 따라 타임라인에서 모든 키프레임 선택",
	"menu.uv": "UV",
	"menu.keyframe": "키프레임",
	"menu.palette.load.update": "팔레트 업데이트",
	"menu.palette.load.update.desc": "이 팔레트를 현재 Blockbench 팔레트로 업데이트",
	"menu.timeline_marker.set_time": "시간 설정...",
	"uv_editor.scale_uv": "UV 크기 조정",
	"action.preview_scene": "씬 미리보기",
	"action.preview_scene.desc": "모델 미리보기 씬 변경하기",
	"preview_scene.minecraft_overworld": "Minecraft 오버월드",
	"preview_scene.minecraft_nether": "Minecraft 네더",
	"preview_scene.minecraft_end": "Minecraft 엔드",
	"dialog.project.modded_entity_flip_y": "Y축 뒤집기",
	"preview_scene.studio": "스튜디오",
	"format.image": "이미지",
	"modifier_actions.set_copy_source": "복사 출처 설정",
	"message.load_images.title": "이미지 불러오기",
	"message.load_images.edit_image": "이미지 수정",
	"dialog.add_primitive.align_edges": "모서리 정렬",
	"dialog.flip_animation.show_in_timeline": "수정된 뼈대를 타임라인에 표시",
	"settings.default_cube_size": "큐브 크기",
	"settings.default_cube_size.desc": "새로운 큐브를 생성할 때 큐브의 기본 크기를 설정",
	"settings.uniform_keyframe": "동일한 크기의 키프레임",
	"settings.uniform_keyframe.desc": "기본적으로 키프레임의 크기를 동일한 크기으로 설정",
	"settings.nearest_rectangle_select": "직사각형 선택: 가장 가까운 가장자리",
	"settings.nearest_rectangle_select.desc": "직사각형 선택을 전체 픽셀 대신 GIMP와 같이 가장 가까운 픽셀 가장자리로 맞춤",
	"settings.pick_color_opacity": "색 투명도 선택",
	"settings.pick_color_opacity.desc": "색상 추출로 색상 불투명도를 선택하고 브러시 불투명도로 설정함",
	"settings.paint_with_stylus_only": "스타일러스펜으로만 칠하기",
	"settings.paint_with_stylus_only.desc": "찾기에는 칠하기, 마우스 제한 또는 터치 입력에만 스타일러스펜을 사용합니다.",
	"action.copy_brush_mode": "브러시 모드 복사",
	"action.copy_brush_mode.copy": "복사",
	"action.copy_brush_mode.pattern": "패턴",
	"action.copy_brush_mode.sample": "샘플",
	"action.brush_shape": "브러시 모양",
	"action.brush_shape.square": "정사각형",
	"action.brush_shape.circle": "원",
	"action.blend_mode": "혼합 모드",
	"action.blend_mode.default": "기본",
	"action.blend_mode.set_opacity": "투명도 설정",
	"action.blend_mode.color": "색",
	"action.blend_mode.behind": "뒤",
	"action.blend_mode.multiply": "곱하기",
	"action.blend_mode.divide": "나누기",
	"action.blend_mode.add": "더하기",
	"action.blend_mode.subtract": "지우기",
	"action.blend_mode.screen": "스크린",
	"action.blend_mode.overlay": "오버레이",
	"action.blend_mode.hard_light": "하드 라이트",
	"action.blend_mode.difference": "차이",
	"action.copy_brush": "브러시 복사",
	"action.copy_brush.desc": "브러시로 텍스쳐의 일부를 복제하거나 패턴을 그립니다. Ctrl 키를 누른 상태에서 클릭하여 복사 할 곳을 선택합니다.",
	"action.validator_window": "모델 문제 보기...",
	"action.validator_window.desc": "현재 모델의 문제를 나열하는 유효성 검사기를 엽니다.",
	"action.cancel_gif": "GIF 취소",
	"menu.text_edit.copy_vector": "벡터 복사",
	"menu.brush_presets.dialog": "브러시 사전 설정...",
	"menu.brush_presets.pixel_brush": "픽셀 브러시",
	"menu.brush_presets.smooth_brush": "스무스 브러시",
	"menu.texture.edit_in_blockbench": "Blockbench에서 수정",
	"menu.mirror_painting.axis": "축",
	"menu.mirror_painting.axis.desc": "대칭되는 축 페인트 스트로크를 선택함",
	"menu.mirror_painting.global": "전역 대칭",
	"menu.mirror_painting.global.desc": "전역 공간에서 모델에 반전 칠하기 사용",
	"menu.mirror_painting.local": "지역 대칭",
	"menu.mirror_painting.local.desc": "각 요소에 대해 로컬 공간에서 반전 칠하기 사용",
	"menu.mirror_painting.texture_frames": "애니메이션 텍스쳐 프레임에서 반복",
	"menu.mirror_painting.texture_frames.desc": "애니메이션 텍스쳐의 모든 프레임에 대한 반전 페인트 스트로크",
	"format.bedrock_block.info.size_limit": "크기 블록의 전체 크기는 모든 곳에서 30픽셀로 제한됩니다. 제한은 블록 중심에서 7픽셀만큼 모든 방향으로 중심을 벗어날 수 있습니다.",
	"format.bedrock_block.info.textures": "Blockbench에서는 여러 큐브에 여러 텍스쳐를 적용할 수 있지만 게임 내에서 올바르게 작동하려면 행동 팩에서 추가 설정이 필요합니다.",
	"format.image.desc": "2D 이미지 편집기에서 이미지 편집",
	"generic.delete_all": "모두 삭제",
	"message.child_model_only.open": "부모 열기",
	"message.child_model_only.open_with_textures": "부모 열기 & 텍스쳐 선택",
	"dialog.project.credit": "크레딧",
	"dialog.convert_project.create_copy": "사본 생성",
	"dialog.texture.frame_time": "프레임 시간",
	"dialog.texture.frame_time.desc": "각 프레임이 표시되는 시간을 눈금 단위로 설정합니다. 한 틱당 1/20초를 의미합니다.",
	"dialog.texture.frame_interpolate": "보간",
	"dialog.texture.frame_interpolate.desc": "다음 프레임으로 교차 페이딩하여 애니메이션 프레임 간 보간",
	"dialog.texture.frame_order_type": "반복 모드",
	"dialog.texture.frame_order_type.loop": "반복",
	"dialog.texture.frame_order_type.backwards": "뒤로 반복",
	"dialog.texture.frame_order_type.back_and_forth": "앞뒤 반복",
	"dialog.texture.frame_order_type.custom": "맞춤 주문",
	"dialog.texture.frame_order": "프레임 순서",
	"dialog.texture.frame_order.desc": "프레임 인덱스를 새 순서로 나열하여 사용자 지정 프레임 순서를 설정합니다. 프레임 인덱스는 첫 번째 프레임부터 0부터 시작합니다.",
	"dialog.select.mode": "모드",
	"dialog.select.mode.new": "새로 선택",
	"dialog.select.mode.add": "선택 항목에 추가",
	"dialog.select.mode.remove": "선택 항목에서 제거",
	"dialog.select.mode.in_selection": "선택 항목에서만 선택",
	"dialog.predicate_overrides.model": "모델",
	"dialog.predicate_overrides.predicates": "조건",
	"dialog.predicate_overrides.variants": "변형",
	"dialog.predicate_overrides.start_value": "시작",
	"dialog.predicate_overrides.add_override": "재정의 추가",
	"dialog.predicate_overrides.add_predicate": "조건 추가",
	"dialog.predicate_overrides.generate_overrides": "재정의 생성",
	"dialog.predicate_overrides.confirm_delete": "모든 재정의를 삭제하시겠습니까?",
	"dialog.predicate_overrides.predicate.angle": "나침반 각도",
	"dialog.predicate_overrides.predicate.blocking": "차단됨",
	"dialog.predicate_overrides.predicate.broken": "고장남",
	"dialog.predicate_overrides.predicate.cast": "던짐",
	"dialog.predicate_overrides.predicate.cooldown": "쿨다운",
	"dialog.predicate_overrides.predicate.damage": "데미지",
	"dialog.predicate_overrides.predicate.damaged": "데미지입음",
	"dialog.predicate_overrides.predicate.lefthanded": "왼손잡이",
	"dialog.predicate_overrides.predicate.pull": "당김 정도",
	"dialog.predicate_overrides.predicate.pulling": "당기고 있음",
	"dialog.predicate_overrides.predicate.charged": "차지중",
	"dialog.predicate_overrides.predicate.firework": "폭죽이 있음",
	"dialog.predicate_overrides.predicate.throwing": "던질 준비",
	"dialog.predicate_overrides.predicate.time": "시간",
	"dialog.predicate_overrides.predicate.custom_model_data": "커스텀 모델 데이터",
	"dialog.predicate_overrides.predicate.level": "빛 세기",
	"dialog.predicate_overrides.predicate.filled": "번들 채워짐 정도",
	"dialog.predicate_overrides.predicate.tooting": "나팔을 붊",
	"settings.model_export_scale": "모델 내보내기 크기",
	"settings.model_export_scale.desc": "내보낸 glTF, DAE 및 FBX 모델의 축소 비율입니다. 기본값은 16이며, 내보내기에서 16 블록벤치 단위를 1미터로 변환합니다.",
	"action.export_fbx": "FBX모델 내보내기",
	"action.export_fbx.desc": "다른 3D 응용 프로그램 및 게임 엔진에서 사용할 수 있도록 모델 및 애니메이션을 fbx 파일로 내보내기",
	"action.center_lateral": "중앙 측면",
	"action.center_lateral.desc": "선택한 요소를 X 및 Z축 중앙에 배치",
	"action.adjust_opacity": "불투명도 조정...",
	"action.adjust_opacity.desc": "선택한 텍스쳐의 불투명도를 조정",
	"action.rotate_texture_cw": "텍스쳐를 시계 방향으로 회전",
	"action.rotate_texture_ccw": "텍스쳐를 시계 반대 방향으로 회전",
	"action.predicate_overrides": "조건자 재정의 편집...",
	"action.predicate_overrides.desc": "선택한 조건에 따라 이 모델을 재정의하려면 모델을 선택하세요.",
	"action.auto_set_cullfaces": "후면 제거를 자동으로 설정",
	"action.auto_set_cullfaces.desc": "인접한 블록에 의해 가려질 때 면을 숨기기 위해 후면 제거를 자동으로 생성합니다.",
	"menu.texture.edit_externally": "외부에서 편집",
	"menu.mirror_painting.texture": "2D 편집기 대칭",
	"menu.mirror_painting.texture.desc": "이미지 또는 텍스쳐의 2D 공간에서 반전 칠하기 활성화",
	"menu.animator.rotation_global": "전역 공간에서 회전",
	"uv_editor.face_properties": "표면 속성",
	"uv_editor.face_properties.material_instance": "머티리얼 인스턴스",
	"uv_editor.tint.info": "표면에 색조를 활성화하여 마인크래프트에 색조를 지정하도록 지시할 수 있습니다. 바닐라에서 색조는 나뭇잎, 레드스톤 가루와 같은 특정 블록에만 사용할 수 있으며 0의 값만 가질 수 있습니다.",
	"uv_editor.cullface.info": "후면 제거를 활성화하면 마인크래프트 세계에서 지정된 방향으로 블록 옆에 다른 전체 블록이 배치되는 경우 블록의 표면이 렌더되지 않게됩니다. 이를 사용하여 성능을 최적화할 수 있습니다.",
	"uv_editor.material_instance.info": "머티리얼 인스턴스는 사용자 정의 이름으로 설정할 수 있습니다. 이 이름은 행동 팩의 블록 JSON 파일에서 표면에에 특정 질감과 재질을 할당하는 데 사용할 수 있습니다.",
	"display.reference.frame_invisible": "아이템 액자 (불투명)",
	"data.settings_profile": "프로필",
	"message.display_skin.invalid_name": "\"%0\" 의 Minecraft 계정을 찾을 수 없습니다.",
	"dialog.load_plugins_from_query.title": "플러그인 불러오기",
	"dialog.load_plugins_from_query.text": "플러그인 설치가 필요한 링크를 사용하였습니다. 해당 플러그인을 설치하시겠습니까?",
	"dialog.select_model.title": "모델 선택하기",
	"dialog.select_model.bones": "본",
	"dialog.select_model.cubes": "큐브",
	"dialog.settings.create_profile": "프로필 생성...",
	"settings_profile.confirm_delete": "이 프로필 설정을 삭제하시겠습니까?",
	"settings_profile.condition.type.selectable": "수동 선택 가능",
	"settings.interface_mode": "UI 모드",
	"settings.interface_mode.desc": "인터페이스 모드. 적용을 위해서는 Blockbench 재시작이 필요합니다",
	"settings.interface_mode.auto": "자동",
	"settings.interface_mode.desktop": "데스크탑",
	"settings.interface_mode.mobile": "모바일",
	"settings.paint_through_transparency": "투명한 픽셀 뒤로 그리기",
	"settings.paint_through_transparency.desc": "투명도 채널이 잠겨 있을 때 투명한 픽셀 뒤로 그리기",
	"action.tab_overview": "탭 개요",
	"action.tab_overview.desc": "열려있는 모든 탭을 보여줍니다",
	"action.slider_color_red": "빨간색",
	"action.slider_color_green": "초록색",
	"action.slider_color_blue": "파란색",
	"action.add_animation_controller": "애니메이션 컨트롤러 추가",
	"action.add_animation_controller.desc": "빈 애니메이션 컨트롤러 생성",
	"action.animation_controller_preview_mode": "컨트롤러 미리보기",
	"action.animation_controller_preview_mode.paused": "일시정지",
	"action.animation_controller_preview_mode.manual": "수동 미리보기",
	"action.animation_controller_preview_mode.play": "자동 미리보기",
	"action.keyframe_interpolation.bezier": "베지어",
	"action.keyframe_bezier_linked": "베지어 손잡이 연결",
	"action.keyframe_bezier_linked.desc": "양쪽 베지어 손잡이 연결",
	"action.reset_keyframe_handles": "키프레임 초기화",
	"action.reset_keyframe_handles.desc": "선택된 키프레임의 베지어 손잡이 초기화",
	"action.looped_animation_playback": "반복 재생",
	"action.looped_animation_playback.desc": "무한 반복 재생",
	"timeline.bind_to_actor": "액터에 바인드",
	"animation_controllers.select_preset": "컨트롤러 프리셋 선택...",
	"animation_controllers.state.animations": "애니메이션",
	"animation_controllers.state.particles": "입자",
	"animation_controllers.state.sounds": "소리",
	"animation_controllers.state.on_entry": "시작 시",
	"animation_controllers.state.on_exit": "종료 시",
	"animation_controllers.state.transitions": "전환 효과",
	"animation_controllers.state.condition": "조건",
	"animation_controllers.state.blend_transition": "블렌드 시간",
	"animation_controllers.state.shortest_path": "최단 경로로 블렌드",
	"animation_controllers.state.edit_transition": "전환 편집",
	"menu.color_picker.picker_type": "스포이트 종류",
	"menu.color_picker.picker_type.square": "사각형",
	"menu.color_picker.picker_type.wheel": "바퀴",
	"menu.color_picker.slider_mode": "슬라이더 모드",
	"menu.color_picker.slider_mode.hsv": "HSV",
	"menu.color_picker.slider_mode.rgb": "RGB",
	"menu.texture.render_mode.additive": "더하기",
	"panel.color.picker_options": "스포이트 설정",
	"panel.animation_controllers": "애니메이션 컨트롤러",
	"display.preset.armor_stand": "지면 (갑옷 거치대)",
	"data.file_path": "파일 경로",
	"dialog.extrude.orientation": "방향",
	"dialog.extrude.orientation.upright": "수직",
	"dialog.extrude.orientation.flat": "평면",
	"dialog.scale.box_uv_warning": "상자 UV 모델의 크기을 조정하면 모델의 UV가 손상될 수 있습니다. 대신 외부에서 모델 스케일을 조정하거나 파일 > 프로젝트에서 표면별 UV 모드로 전환하세요.",
	"dialog.create_gif.format": "포맷",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "PNG 순서",
	"dialog.create_gif.pixelate": "픽셀화",
	"dialog.create_gif.bg_image": "배경 이미지",
	"dialog.create_gif.turn.desc": "녹화하는 동안 모델을 회전합니다. 음수 값을 사용하여 모델을 시계 방향으로 돌립니다. 60 값은 초당 한 번 회전하는 것을 의미합니다.",
	"settings_profile.condition": "조건",
	"settings_profile.condition.type.file_path.desc": "정규식 구문을 사용하여 현재 프로젝트의 파일 경로와 일치시킵니다. 파일 경로에 슬래시를 사용하세요",
	"settings.only_selected_bezier_handles": "선택한 베지어 핸들만 표시하기",
	"settings.only_selected_bezier_handles.desc": "현재 선택되지 않은 베지어 키프레임의 핸들 숨기기",
	"settings.embed_textures": "텍스쳐 임베드",
	"settings.embed_textures.desc": "텍스쳐 파일 콘텐츠를 .bbmodel 파일에 임베드",
	"action.selection_mode.cluster": "클러스터",
	"dialog.copied_to_clipboard": "클립보드에 복사됨",
	"data.reference_image": "참조용 이미지",
	"message.delete_reference_image": "이 참조용 이미지를 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.",
	"message.add_reference_image.message": "참조용 이미지를 로드할 위치 선택",
	"message.add_reference_image.project": "이 프로젝트에 추가하기",
	"message.add_reference_image.app": "모든 프로젝트에 추가하기",
	"message.import_particle_texture.import": "파티클 이미지 가져오기",
	"message.import_particle_texture.message": "파티클에 사용할 텍스쳐 파일을 가져오시겠습니까?",
	"message.save_codec_selector.title": "모델 형식 저장",
	"message.save_codec_selector.message": "모델을 저장할 형식을 선택합니다.",
	"message.save_codec_selector.project_file": "Blockbench 프로젝트 (.bbmodel)",
	"message.save_codec_selector.both": "둘 다",
	"message.display_skin.username": "닉네임 (Java)",
	"message.palette_locked": "팔레트가 잠겨 있습니다",
	"dialog.project.default_uv_mode": "기본 UV 모드",
	"dialog.project.default_uv_mode.description": "프로젝트의 기본 UV 모드입니다. UV 모드는 큐브별로 변경할 수도 있습니다.",
	"dialog.export_options.title": "내보내기 옵션",
	"dialog.edit_texture.preview": "미리보기",
	"dialog.proportional_editing.range": "범위",
	"dialog.proportional_editing.falloff": "폴오프",
	"dialog.proportional_editing.falloff.linear": "선형",
	"dialog.proportional_editing.falloff.hermite_spline": "스무스",
	"dialog.proportional_editing.falloff.constant": "컨스턴트",
	"dialog.proportional_editing.selection": "선택",
	"dialog.proportional_editing.selection.linear": "선형 거리",
	"dialog.proportional_editing.selection.connections": "연결",
	"dialog.mirror_painting_texture_center.middle": "중간",
	"dialog.mirror_painting_texture_center.custom": "사용자 지정",
	"dialog.settings.reset_to_default": "기본값으로 재설정",
	"keybindings.item.num_slider.increase": "증가",
	"keybindings.item.num_slider.decrease": "감소",
	"settings.always_show_splash_art": "항상 스플래시 아트 표시",
	"settings.always_show_splash_art.desc": "시작 화면에 항상 스플래시 아트를 표시합니다",
	"action.slider_palette_color": "팔레트 색상 전환",
	"action.slider_palette_color.desc": "팔레트의 색상 순환",
	"action.proportional_editing": "비율 편집",
	"action.proportional_editing.desc": "메쉬의 일부를 편집할 때 주변 정점에 비례적으로 영향을 줍니다",
	"action.limit_to_palette": "팔레트 제한",
	"action.limit_to_palette.desc": "텍스쳐의 색상을 현재 로드된 팔레트에 있는 색상으로 제한합니다",
	"action.edit_reference_images": "참조용 이미지 편집",
	"action.edit_reference_images.desc": "참조용 이미지 모드를 켜서 참조용 이미지와 청사진을 추가하거나 편집함",
	"action.add_reference_image": "참조용 이미지 추가",
	"action.reference_image_from_clipboard": "클립보드의 참조용 이미지",
	"action.reference_image_list": "참조용 이미지",
	"action.connect_uv_faces": "UV 표면 연결",
	"action.connect_uv_faces.desc": "선택한 UV 표면을 마지막으로 선택한 UV 표면에 연결",
	"action.merge_uv_vertices": "UV 정점 병합",
	"action.merge_uv_vertices.desc": "처음 선택한 UV 정점을 마지막으로 선택한 UV 정점에 맞춥니다",
	"action.bedrock_animation_mode": "Bedrock 애니메이션 모드",
	"action.bedrock_animation_mode.desc": "마인크래프트 베드락에디션의 에니매이션을 편집할 모드를 선택",
	"action.bedrock_animation_mode.entity": "엔티티",
	"action.bedrock_animation_mode.attachable_first": "아이템 1인칭",
	"action.bedrock_animation_mode.attachable_third": "아이템 3인칭",
	"timeline.amplify": "증폭",
	"menu.options": "옵션...",
	"menu.palette.lock_palette": "팔레트 잠금",
	"menu.uv.export": "UV 매핑 내보내기",
	"menu.uv.flip_x": "X 반전",
	"menu.uv.flip_y": "Y 반전",
	"menu.mirror_painting.enabled": "켜짐",
	"reference_image.position": "위치",
	"reference_image.size": "크기",
	"reference_image.rotation": "회전",
	"reference_image.opacity": "투명도",
	"reference_image.visibility": "가시성",
	"reference_image.clear_mode": "지우기 모드",
	"reference_image.layer": "레이어",
	"reference_image.layer.background": "모델 아래",
	"reference_image.layer.viewport": "모델 위",
	"reference_image.layer.float": "인터페이스 위",
	"reference_image.scope": "범위",
	"reference_image.scope.project": "이 프로젝트만",
	"reference_image.scope.global": "모든 프로젝트",
	"reference_image.enabled_modes": "모드에서 활성화됨",
	"codec.common.encoding": "인코딩",
	"codec.common.armature": "그룹을 뼈대로 내보내기",
	"codec.common.export_animations": "에니메이션 추출",
	"codec.common.embed_textures": "텍스쳐 임베드",
	"preview.center_camera": "중앙 카메라",
	"display.reference.frame_top": "아이템 액자 위",
	"display.reference.frame_top_invisible": "아이템 액자 위 (투명)",
	"action.proportional_editing_range": "비율 편집 범위",
	"action.proportional_editing_range.desc": "비율 편집 범위 조정",
	"action.toggle_all_reference_images": "모든 참조용 이미지 숨기기/보기",
	"action.toggle_all_reference_images.desc": "모든 참조용 이미지의 표시 여부를 한 번에 전환",
	"action.add_animation_controller_state": "애니메이션 컨트롤러 상태 추가",
	"action.add_animation_controller_state.desc": "애니메이션 컨트롤러에 새로운 상태 추가",
	"menu.slider.round_value": "라운드 값",
	"texture.error.too_large": "해상도가 최대 %0을 초과함",
	"dialog.copy_to_clipboard": "클립보드에 복사",
	"dialog.open_url": "URL 열기",
	"reference_image.image": "이미지",
	"uv_editor.rotate_uv": "UV 회전",
	"generic.error": "Error",
	"projects.start_screen": "Start Screen",
	"message.invalid_link.message": "The shared model \"%0\" that you are trying to load is either invalid or has expired.",
	"message.plugin_dependencies.title": "Plugin Dependencies",
	"message.plugin_dependencies.message1": "The plugin requires these dependencies:",
	"message.plugin_dependencies.message1_update": "The plugin %0 has been updated and now requires these dependencies:",
	"message.plugin_dependencies.message2": "Do you want to install them to continue?",
	"message.plugin_dependencies.invalid": "Unfortunately the plugin cannot be installed, it has an invalid dependency:",
	"message.preview_scene_load_failed": "Failed to load preview scene. Check your internet connection.",
	"dialog.convert_project.text1": "Convert the project into a different format.",
	"dialog.convert_project.text2": "Use conversion at your own risk. Formats have different features and restrictions, so converting will in some cases break parts of your project.",
	"dialog.convert_project.text3": "You cannot undo converting, that is why by default a copy will be created.",
	"dialog.unsaved_work.title": "Unsaved Work",
	"dialog.unsaved_work.text": "The following projects contain unsaved changes. Do you want to save your changes?",
	"dialog.unsaved_work.discard_all": "Discard All",
	"dialog.unsaved_work.save_all": "Save All",
	"dialog.resize_texture.mode": "Mode",
	"dialog.resize_texture.mode.crop": "Crop/Expand",
	"dialog.resize_texture.mode.scale": "Scale",
	"dialog.plugins.is_installed": "Installed",
	"dialog.plugins.is_disabled": "Disabled",
	"dialog.plugins.disable": "Disable",
	"dialog.plugins.enable": "Enable",
	"dialog.plugins.dependencies": "Depends on:",
	"dialog.view_backups.open_folder": "Open Folder",
	"dialog.share_model.reference_images": "Include Reference Images",
	"dialog.share_model.too_large": "Failed to upload: Model is too large",
	"dialog.share_model.too_large_references": "Failed to upload: Model is too large. Try without reference images.",
	"settings.stretch_linked": "Link Stretching",
	"settings.stretch_linked.desc": "Stretch the cube in all directions with the same value",
	"settings.grids": "Show Grids",
	"settings.grids.desc": "Show or hide all 3D grids",
	"settings.double_click_switch_tools": "Switch Tools on Double Click",
	"settings.double_click_switch_tools.desc": "Double click the viewport to switch between tools",
	"settings.outlines_in_paint_mode": "Selection Outlines in Paint Mode",
	"settings.outlines_in_paint_mode.desc": "Display element selection outlines while in paint mode",
	"settings.json_indentation": "JSON Indentation",
	"settings.json_indentation.desc": "Indentation style for exported JSON files",
	"settings.json_indentation.tabs": "Tabs",
	"settings.json_indentation.spaces_4": "Spaces: 4",
	"settings.json_indentation.spaces_2": "Spaces: 2",
	"action.slider_stretch": "Stretch",
	"action.slider_stretch.desc": "Stretches cubes multiplicatively on the %0 axis without changing the UV",
	"action.view_backups": "View Backups",
	"action.view_backups.desc": "Browse the list of auto-saved project backups",
	"action.search_outliner": "Search Outliner",
	"action.search_outliner.desc": "Search for specific element names in the outliner",
	"action.mirror_modeling": "Mirror Modeling",
	"action.mirror_modeling.desc": "Enable Mirror Modeling on the X axis. All changes you make in the viewport will be reflected to the other side, unless specifically disabled on the element.",
	"action.allow_element_mirror_modeling": "Allow Mirror Modeling",
	"action.allow_element_mirror_modeling.desc": "Choose whether the selected elements can be affected by mirror modeling",
	"action.switch_face_crease": "Switch Face Crease",
	"action.switch_face_crease.desc": "Switch in which direction the quad folds in the middle",
	"action.clear_unused_texture_space": "Clear Unused Texture Space",
	"action.clear_unused_texture_space.desc": "Clear parts of the texture that are not UV-mapped to any elements",
	"action.split_screen": "Split Screen",
	"action.split_screen.desc": "Select a viewport split screen mode",
	"action.split_screen.single": "Single",
	"action.split_screen.double_horizontal": "Double Horizontal",
	"action.split_screen.double_vertical": "Double Vertical",
	"action.split_screen.quad": "Quad",
	"action.split_screen.triple_left": "Triple Left",
	"action.split_screen.triple_right": "Triple Right",
	"action.split_screen.triple_top": "Triple Top",
	"action.split_screen.triple_bottom": "Triple Bottom",
	"action.uv_project_from_view": "UV Project from View",
	"action.uv_project_from_view.desc": "Automatically generate UVs for the selected faces from the perspective of the 3D view",
	"action.graph_editor_other_graphs": "Display Other Graphs",
	"action.graph_editor_other_graphs.desc": "Whether the graphs of the axes that are not selected are displayed",
	"action.graph_editor_include_other_graphs": "Include Other Graphs",
	"action.graph_editor_include_other_graphs.desc": "Whether the graph editor includes the graphs that are not selected in the view",
	"action.set_ik_source": "Set IK Root",
	"action.set_ik_source.desc": "Select the root bone of the chain that should be moved by this null object via Inverse Kinematics",
	"edit.loop_cut.cuts": "Cuts",
	"panel.element.stretch": "Stretch",
	"preview_scene.minecraft_plains": "Plains",
	"preview_scene.minecraft_cherry_grove": "Cherry Grove",
	"preview_scene.minecraft_snowy_tundra": "Snowy Tundra",
	"preview_scene.minecraft_sunset": "Sunset",
	"preview_scene.minecraft_night": "Night",
	"preview_scene.minecraft_desert": "Desert",
	"preview_scene.minecraft_underwater": "Underwater",
	"preview_scene.minecraft_coral_reef": "Coral Reef",
	"preview_scene.minecraft_lush_cave": "Lush Cave",
	"preview_scene.minecraft_deep_dark": "Deep Dark",
	"generic.navigate_forward": "Forward",
	"generic.navigate_back": "Back",
	"action.element_render_order": "Transparency Render Order",
	"action.element_render_order.default": "Auto",
	"action.element_render_order.behind": "Behind",
	"action.element_render_order.in_front": "In Front",
	"message.installing_update.title": "Update Available",
	"message.installing_update.message": "A new version is ready to be installed. After closing the app, please allow for around %0 seconds before opening Blockbench again or turning off the computer, for the update to be installed.",
	"settings.brush_cursor_2d": "2D Brush Cursor",
	"settings.brush_cursor_2d.desc": "Display an outline around the brush in the 2D workspace",
	"settings.brush_cursor_3d": "3D Brush Cursor",
	"settings.brush_cursor_3d.desc": "Display an outline around the brush in the 3D workspace",
	"settings.cdn_mirror": "Use CDN Mirror",
	"settings.cdn_mirror.desc": "Use the mirror CDN to download plugins. The mirror receives updates faster and works in some regions where the default does not work.",
	"data.layer": "Layer",
	"data.panel": "Panel",
	"generic.confirm_delete": "Are you sure you want to delete this?",
	"format_category.general": "General",
	"modifier_actions.no_uniform_scaling": "Free Scaling",
	"message.texture_refresh_conflict.title": "Conflicting Texture Versions",
	"message.texture_refresh_conflict.message": "The texture file might contain changes that conflict with Blockbench's version",
	"message.texture_refresh_conflict.keep_ours": "Keep Blockbench's version",
	"message.texture_refresh_conflict.keep_theirs": "Load file and discard all changes and layers in Blockbench",
	"message.group_required_to_animate": "You cannot animate this type of element. Create a group or armature to animate it.",
	"dialog.texture.uv_size": "UV Size",
	"dialog.advanced_screenshot.angle_preset": "Angle Preset",
	"dialog.advanced_screenshot.resolution": "Resolution",
	"dialog.advanced_screenshot.zoom_to_fit": "Zoom To Fit",
	"dialog.advanced_screenshot.zoom": "Zoom / Focal Length",
	"dialog.advanced_screenshot.anti_aliasing": "Anti-aliasing",
	"dialog.advanced_screenshot.anti_aliasing.off": "Off",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "Multisampling",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "Supersampling",
	"dialog.advanced_screenshot.show_gizmos": "Show Edit Gizmos",
	"dialog.advanced_screenshot.shading": "Shading",
	"settings.auto_keyframe": "Auto Keyframe",
	"settings.auto_keyframe.desc": "Automatically create a keyframe with default values at the timeline start when transforming the bone at a later point",
	"settings.modded_entity_integer_size": "Modded Entity Integer Size",
	"settings.modded_entity_integer_size.desc": "Limit cube sizes in the Modded Entity format to integers. While floats are technically supported in some versions, integers are much easier to UV-map.",
	"category.layers": "Layers",
	"keybind.paint_secondary_color": "Paint with Secondary Color",
	"action.selection_tool_operation_mode": "Selection Operation Mode",
	"action.selection_tool_operation_mode.create": "New Selection",
	"action.selection_tool_operation_mode.add": "Add to Selection",
	"action.selection_tool_operation_mode.subtract": "Subtract from Selection",
	"action.selection_tool_operation_mode.intersect": "Intersect",
	"action.pixel_perfect_drawing": "Pixel Perfect Drawing",
	"action.pixel_perfect_drawing.desc": "Draw smooth pixel-art lines without double pixels at curves",
	"action.selection_tool": "Selection Tool",
	"action.selection_tool.desc": "Select parts of the image",
	"action.selection_tool.rectangle": "Rectangle",
	"action.selection_tool.ellipse": "Ellipse",
	"action.selection_tool.lasso": "Lasso Select",
	"action.selection_tool.wand": "Magic Wand",
	"action.selection_tool.color": "Same Color",
	"action.move_layer_tool": "Move Layer",
	"action.move_layer_tool.desc": "Move the current layer or selection",
	"action.export_modded_animations": "Export Modded Entity Animations",
	"action.export_modded_animations.desc": "Export animations for a Minecraft Java Edition modded entity model",
	"action.swap_colors": "Swap Colors",
	"action.swap_colors.desc": "Swap the main color with the secondary color",
	"action.apply_mesh_rotation": "Apply Rotation",
	"action.apply_mesh_rotation.desc": "Reset the element rotation of the mesh, and apply it to the geometry instead",
	"action.flip_texture_x.desc": "Flip the texture or layer horizontally",
	"action.flip_texture_y.desc": "Flip the texture or layer vertically",
	"action.rotate_texture_cw.desc": "Rotate the texture or layer clockwise",
	"action.rotate_texture_ccw.desc": "Rotate the texture or layer counter-clockwise",
	"action.crop_texture_to_selection": "Crop Texture to Selection",
	"action.create_empty_layer": "Create Empty Layer",
	"action.enable_texture_layers": "Enable Layers",
	"action.disable_texture_layers": "Disable Layers",
	"action.layer_opacity": "Layer Opacity",
	"action.layer_to_texture_size": "Expand Layer to Texture Size",
	"action.layer_to_texture_size.desc": "Expand the layer to the size of the texture",
	"action.merge_layer_down": "Merge Down",
	"action.merge_layer_down.desc": "Merge into the layer below",
	"action.advanced_screenshot": "Advanced Screenshot...",
	"action.advanced_screenshot.desc": "Take a screenshot of the model with advanced options",
	"action.bake_ik_animation": "Bake Inverse Kinematics",
	"action.bake_ik_animation.desc": "Bake the rotations applied by inverse kinematics into the selected animation",
	"action.save_animation_preset": "Save Animation Preset...",
	"action.save_animation_preset.desc": "Save the selected keyframes as an animation preset",
	"action.animation_onion_skin": "Animation Onion Skin",
	"action.animation_onion_skin.desc": "Display an wireframe view of a different frame in the animation for reference",
	"action.apply_animation_preset": "Apply Animation Preset",
	"action.apply_animation_preset.desc": "Select from a list of animation presets and apply it to the selected bone",
	"menu.brush_presets.pixel_perfect": "Pixel-perfect Brush",
	"panel.layers": "Layers",
	"uv_editor.copy_paste_tool.to_layer": "To New Layer",
	"format.image.new": "Create New Image",
	"format.image.info.summary": "The 2D Image editor lets you create and edit images and pixel art directly in Blockbench, without the need for an external image editor. Edit images, modify textures, or create your own pixel art!",
	"settings.move_with_selection_tool": "Use Selection Tool to Move Selections",
	"settings.move_with_selection_tool.desc": "Allow the Selection Tool to directly move selections, without having to switch to the Move Layer tool",
	"settings.final_newline": "Final Newline",
	"settings.final_newline.desc": "Insert a newline character at the end of exported files",
	"action.crop_layer_to_selection": "Crop Layer to Selection",
	"action.edit_mode_uv_overlay.desc": "Display the UV map overlay for all elements in edit mode",
	"menu.image": "Image",
	"menu.texture.discard_changes": "Discard Changes",
	"menu.texture.discard_changes.desc": "Discard all unsaved changes and load the latest version from the file",
	"panel.textures.images": "Images",
	"dialog.advanced": "Advanced",
	"dialog.recommended_option": "recommended",
	"modifier_actions.snap_to_center": "Snap to Center",
	"modifier_actions.snap_to_pixels": "Snap to Pixels",
	"message.invalid_format.install_plugin": "Install plugin '%0'",
	"message.plugin_deprecated.message": "Are you sure you want to install this deprecated plugin?",
	"message.plugin_deprecated.install_anyway": "Install Anyway",
	"message.image_editor.not_found": "Could not find the selected image editor. Please select a different option.",
	"message.knife_tool.confirm": "Press %0 or click here to apply Knife Tool",
	"message.knife_tool.skipped_face": "Cannot cut between different faces. Include the edges or vertices between them!",
	"message.optimize_animation.keyframes_removed": "Removed %0 redundant keyframes",
	"message.optimize_animation.nothing_to_optimize": "Found nothing to optimize!",
	"message.duplicate_bone_copy_animation.title": "Copy Animation",
	"message.duplicate_bone_copy_animation.message": "The duplicated bone is animated in %0 animations. Do you want to copy the keyframes over to the new bone?",
	"message.auto_fix_mesh_edit.title": "Auto Fix",
	"message.auto_fix_mesh_edit.revert": "Revert Edit",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Certain vertices have been moved into the same spot. How would you like to proceed?",
	"message.auto_fix_mesh_edit.concave_quads": "One or more quad faces are now concave, which can cause issues in UV-mapping and rendering. Blockbench can automatically fix it for you:",
	"message.auto_fix_mesh_edit.merge_vertices": "Merge Vertices",
	"message.auto_fix_mesh_edit.split_quads": "Split Quads",
	"message.load_images.add_image": "Add Image",
	"dialog.project.modded_entity_entity_class": "Entity Class",
	"dialog.resize_texture.offset": "Offset",
	"dialog.animated_texture_editor.code_reference": "Code Reference",
	"dialog.animated_texture_editor.code_reference.about": "This code to implement the texture animation was generated as a reference and does not necessarily work without modification. Check out the documentation to learn more.",
	"dialog.animated_texture_editor.code_reference.docs": "Documentation",
	"dialog.animated_texture_editor.reframe": "Reframe",
	"dialog.animated_texture_editor.stride": "Frame Size",
	"dialog.animated_texture_editor.frames": "Number of Frames",
	"dialog.animated_texture_editor.add_frame": "Add Frame",
	"dialog.animated_texture_editor.resize_frames": "Resize Frames...",
	"dialog.animated_texture_editor.apply": "Apply",
	"dialog.add_primitive.edge_size": "Edge Size",
	"dialog.change_animation_speed.speed": "Speed",
	"dialog.change_animation_speed.adjust_snapping": "Adjust Snapping",
	"dialog.optimize_animation.selection": "Selection",
	"dialog.optimize_animation.selection.selected_keyframes": "Selected Keyframes",
	"dialog.optimize_animation.selection.selected_animation": "Selected Animation",
	"dialog.optimize_animation.selection.all_animations": "All Animations",
	"dialog.optimize_animation.thresholds": "Threshold values",
	"dialog.import_obj.obj": "OBJ File",
	"dialog.import_obj.mtl": "MTL File",
	"dialog.import_obj.scale": "Scale",
	"layout.thumbnail": "Custom Thumbnail CSS",
	"settings.pixel_grid": "Pixel Grid",
	"settings.pixel_grid.desc": "Show texture pixel grid on elements in edit mode",
	"settings.image_editor_grid_size": "Image Editor Grid Size",
	"settings.image_editor_grid_size.desc": "Size of the large grid in the 2D image editor",
	"settings.ground_plane_double_side": "Ground Plane Double-sided",
	"settings.ground_plane_double_side.desc": "Make the ground plane visible from below",
	"settings.optifine_save_default_texture": "OptiFine JEM: Export selected texture",
	"settings.optifine_save_default_texture.desc": "Export the selected texture as the default texture of the model",
	"action.slider_color_select_threshold": "Color Select Threshold",
	"action.slider_color_select_threshold.desc": "How close the color of a neighboring pixel has to be to get selected by color or wand select",
	"action.stretch_tool": "Stretch",
	"action.stretch_tool.desc": "Tool to select and stretch elements",
	"action.knife_tool": "나이프 도구",
	"action.knife_tool.desc": "Tool to cut mesh faces into smaller pieces",
	"action.duplicate_project": "Duplicate Project",
	"action.duplicate_project.desc": "Creates a copy of the open project",
	"action.transform_space.parent": "Parent",
	"action.transform_pivot_space": "Pivot Transform Space",
	"action.solidify_mesh_selection": "Solidify Faces",
	"action.solidify_mesh_selection.desc": "Solidify the selected faces of the mesh",
	"action.animated_texture_editor": "Flipbook Editor...",
	"action.animated_texture_editor.desc": "Edit the flipbook animation of the selected texture",
	"action.center_individual_pivots": "Center Individual Pivots",
	"action.center_individual_pivots.desc": "Set the pivot point of each selected element to its center",
	"action.uv_cycle": "Cycle UV",
	"action.uv_cycle.desc": "Cycle through the order of UV vertices without changing the UV positions",
	"action.uv_cycle_invert": "Cycle Invert UV",
	"action.uv_cycle_invert.desc": "Reverse the order of UV vertices without changing the UV positions",
	"action.slider_animation_controller_speed": "Controller Playback Speed",
	"action.slider_animation_controller_speed.desc": "The playback speed of animation controllers in percent",
	"action.optimize_animation": "Optimize Animation",
	"action.optimize_animation.desc": "Optimize the current animation and reduce the keyframe count",
	"action.change_animation_speed": "Change Animation Speed...",
	"action.change_animation_speed.desc": "Change the speed of the selected animation",
	"timeline.select_particle_file": "Select Particle File",
	"timeline.select_sound_file": "Select Sound File",
	"menu.cube.texture.default": "Default",
	"menu.texture.particle.clear": "Stop using for Particles",
	"menu.texture.use_as_default": "Set as Default",
	"menu.texture.use_as_default.clear": "Unassign as Default",
	"menu.toolbar.overflow": "Toolbar Overflow",
	"edit.solidify_mesh_selection.thickness": "Thickness",
	"reference_image.sync_to_timeline": "Sync To Timeline",
	"reference_image.toggle_playback": "Play/Pause",
	"dialog.add_primitive.shape.beveled_cuboid": "Beveled Cuboid",
	"dialog.ignore_all": "Ignore All",
	"data.texture_group": "Texture Group",
	"data.animation": "Animation",
	"generic.on": "On",
	"generic.off": "Off",
	"format.free.info.3d_printing": "3D Printing",
	"message.invalid_file.merge_conflict": "The file contains unresolved Git merge conflicts.",
	"dialog.expand_texture_selection.radius": "Amount",
	"dialog.expand_texture_selection.corner": "Corner Shape",
	"dialog.expand_texture_selection.corner.round": "Round",
	"dialog.expand_texture_selection.corner.square": "Square",
	"dialog.expand_texture_selection.corner.manhattan": "Manhattan",
	"dialog.merge_animation.merge_target": "Merge into",
	"keybindings.variation_conflict": "Variation conflicts with the main keybinding",
	"settings.recovery_save_interval": "Recovery Point Save Interval",
	"settings.recovery_save_interval.desc": "Blockbench regularly saves the open project in the background to recover in case of a computer crash. Set the interval in seconds. Set to 0 to disable saving.",
	"settings.save_view_per_tab": "Save View per Tab",
	"settings.save_view_per_tab.desc": "Save the current view angle for each tab separately",
	"settings.inherit_parent_color": "Inherit Parent Color",
	"settings.inherit_parent_color.desc": "Set the marker color of a newly created element to the color of the parent instead of a random color",
	"keybind.preview_select.multi_select": "Multi-select",
	"keybind.preview_select.group_select": "Group-select",
	"keybind.preview_select.loop_select": "Loop-select",
	"action.fill_mode.selection": "Selection",
	"action.fill_mode.selected_elements": "Selected Elements",
	"action.image_tiled_view": "Tiled View",
	"action.image_tiled_view.description": "Enable the tiled view in the 2D editor",
	"action.image_onion_skin_view": "Image Editor Onion Skin",
	"action.image_onion_skin_view.description": "Enable the onion skin view in the 2D editor",
	"action.expand_texture_selection": "Expand Texture Selection",
	"action.expand_texture_selection.desc": "Expand or shrink the texture selection",
	"action.switch_tabs.reverse_order": "Reverse order",
	"action.save_project_incremental": "Save Project With Increment",
	"action.save_project_incremental.desc": "Saves the current model as a project file with an increment (ex: project_2.bbmodel)",
	"action.copy.multiple": "Copy All",
	"action.copy.multiple.desc": "Copy all available data individually",
	"action.paste.multiple": "Paste All",
	"action.randomize_marker_colors": "Randomize Marker Colors",
	"action.cube_light_emission": "Light Emission",
	"action.cube_light_emission.desc": "Change the emissiveness of the selected cubes, as a value between 0 and 15",
	"action.view_mode.colored_solid": "Solid with Marker Colors",
	"action.focus_on_selection.rotate_only": "Rotate only",
	"action.create_texture_group": "Create Texture Group",
	"action.create_texture_group.desc": "Create a group for your textures",
	"action.uv_maximize.all_faces": "Affect all faces",
	"action.retarget_animators": "Retarget Animations",
	"action.retarget_animators.desc": "Select which animator targets which bone or element",
	"action.merge_animation": "Merge Animation",
	"action.merge_animation.desc": "Merge the animation into another animation",
	"action.add_keyframe.reset_values": "With default values",
	"action.set_timeline_range_start": "Set Timeline Range Start",
	"action.set_timeline_range_start.desc": "Set the start point for a custom playback range in the animation timeline",
	"action.set_timeline_range_end": "Set Timeline Range End",
	"action.set_timeline_range_end.desc": "Set the end point for a custom playback range in the animation timeline",
	"action.disable_timeline_range": "Disable Timeline Range",
	"action.disable_timeline_range.desc": "Disable the custom playback range in the animation timeline",
	"menu.texture_group.resolve": "Resolve",
	"menu.image_tiled_view.mirrored": "Mirrored Edges",
	"menu.image_onion_skin_view.frame": "Frames",
	"menu.image_onion_skin_view.frame.last_viewed": "Last Viewed Frame",
	"menu.image_onion_skin_view.frame.previous": "Previous Frame",
	"menu.image_onion_skin_view.frame.next": "Next Frame",
	"menu.image_onion_skin_view.frame.both": "Previous + Next",
	"menu.image_onion_skin_view.display": "Display",
	"menu.image_onion_skin_view.display.pixels": "Smaller Pixels",
	"menu.image_onion_skin_view.display.transparent": "Transparent",
	"menu.image_onion_skin_view.above": "Display Above",
	"menu.animation.reload": "Reload",
	"switches.autouv.alt": "Relative",
	"display.rotation_pivot": "Rotation Pivot",
	"display.scale_pivot": "Scale Pivot",
	"display.reference.fox": "Fox",
	"display.reference.eating": "Eating",
	"preview_scene.sky": "Sky",
	"preview_scene.space": "Space",
	"preview_scene.minecraft_ocean": "Ocean",
	"message.import_palette.selection_only": "Selection only",
	"dialog.blend_transition_edit.ease_in_out": "Ease-in-out (%0)",
	"dialog.blend_transition_edit.generate": "Generate...",
	"dialog.blend_transition_edit.generate.learn_more": "More info and preview",
	"dialog.blend_transition_edit.generate.curve": "Easing Type",
	"dialog.blend_transition_edit.generate.steps": "Keyframes",
	"settings.fps_limit": "FPS Limit",
	"settings.fps_limit.desc": "Limit how many frames per second Blockbench renders. The actual frame rate is limited to what your device can display.",
	"settings.outliner_reveal_on_select": "Reveal Elements on Select",
	"settings.outliner_reveal_on_select.desc": "Reveal elements in the ouliner when selected",
	"settings.java_export_pivots": "Export Pivots in Java block/item models",
	"settings.java_export_pivots.desc": "Save pivot points in Java block/item models on cubes without rotation",
	"animation_controllers.state.blend_transition_curve": "Blend Transition Curve",
	"menu.slider.reset_vector": "Reset Vector",
	"dialog.blend_transition_edit.extended": "Extended Graph",
	"message.screenshot_too_large.title": "Screenshot Resolution Issue",
	"message.screenshot_too_large.message": "The screenshot could not be rendered successfully. Please try again with a lower resolution or without supersampling.",
	"message.rename_elements.numbering": "You can use special characters to generate sequential numbers: % to get the index of the element within its group, $ to get the index within the selection.",
	"generic.edit_externally": "Edit Externally",
	"message.settings_require_restart.title": "Restart Required",
	"message.settings_require_restart.message": "Some settings will only apply after restarting the program.",
	"message.settings_require_restart.restart_now": "Restart Now",
	"message.settings_require_restart.restart_later": "Restart Later",
	"message.classroom_mode.install_plugin": "Cannot install plugins in Classroom Mode",
	"dialog.collection.export_path": "Export Path",
	"dialog.collection.select_all": "Select All",
	"dialog.collection.select_none": "Select None",
	"dialog.collection.add_with_filter": "Add with Filter",
	"dialog.collection.remove": "Remove",
	"dialog.material_config.title": "Material Config",
	"dialog.material_config.color_value": "Color Value",
	"dialog.material_config.mer": "Metal-Emissive-Roughness",
	"dialog.material_config.mer_value": "MER Value",
	"dialog.material_config.depth_type": "Depth Type",
	"dialog.create_texture.disable_mirror_uv": "Disable UV Mirroring",
	"dialog.create_texture.disable_mirror_uv.desc": "Disable the UV Mirror option in Mirror Modeling to preserve separate UVs for each side of the model",
	"dialog.create_gif.turn.sync_to_anim_length": "Sync to animation length",
	"settings.category.controls": "Controls",
	"settings.classroom_mode": "Classroom Mode",
	"settings.classroom_mode.desc": "Restricts functionality such as installing plugins and removes links to social media",
	"settings.antialiasing_bleed_fix": "Fix anti-aliasing bleeding",
	"settings.antialiasing_bleed_fix.desc": "Fixes texture bleeding when using anti-aliasing. Potentially unsupported on older hardware.",
	"settings.tone_mapping": "Tone Mapping",
	"settings.tone_mapping.desc": "Approximation method for displaying high dynamic range on a standard screen for PBR rendering.",
	"settings.audio_scrubbing": "Timline Scrubbing Audio",
	"settings.audio_scrubbing.desc": "Play short previews of the audio while scrubbing through time timeline",
	"settings.viewport_rotate_speed": "Viewport Rotate Speed",
	"settings.viewport_rotate_speed.desc": "Input sensitivity when rotating in the viewport",
	"settings.viewport_zoom_speed": "Viewport Zoom Speed",
	"settings.viewport_zoom_speed.desc": "Input sensitivity when zooming in the viewport",
	"settings.editor_2d_zoom_speed": "2D Editor Zoom Speed",
	"settings.editor_2d_zoom_speed.desc": "Input sensitivity when zooming in the UV and 2D paint editor",
	"category.select": "Select",
	"action.vertex_snap_mode.rotate": "Rotate",
	"action.export_image": "Export Image",
	"action.export_image.desc": "Export your texture as an image file",
	"action.apply_mirror_modeling": "Apply Mirror Modeling",
	"action.apply_mirror_modeling.desc": "Apply Mirror Modeling to the selection. All selected elements will be copied and flipped across the X axis.",
	"action.create_collection": "Create Collection",
	"action.create_collection.desc": "Create a collection out of the outliner selection",
	"action.set_collection_content_to_selection": "Set Collection Content to Selected",
	"action.set_collection_content_to_selection.desc": "Set the selected groups and elements as the content of the collection",
	"action.add_to_collection": "Add Selected to Collection",
	"action.add_to_collection.desc": "Add the selected groups and elements to the collection",
	"action.view_mode.material": "Material Preview",
	"action.create_material": "Create Material",
	"action.create_material.desc": "Create a new PBR material out of the selected texture",
	"action.generate_pbr_map": "Generate PBR Map...",
	"action.generate_pbr_map.desc": "Generate a PBR map (height map or metalness, emissiveness, roughness) from an existing texture",
	"menu.tools.main_tools": "Toolbox",
	"menu.view.panels": "Panels",
	"menu.texture.pbr_channel": "PBR Channel",
	"menu.texture.pbr_channel.color": "Color",
	"menu.texture.pbr_channel.normal": "Normal",
	"menu.texture.pbr_channel.height": "Height",
	"menu.texture.pbr_channel.mer": "MER (Metalness-Emissive-Roughness)",
	"menu.texture.pbr_channel.mer_subsurface": "MER Subsurface",
	"menu.collection.export_project": "Export Project",
	"menu.collection.export_as": "Export as \"%0\"",
	"menu.panel.enable": "Enable",
	"menu.panel.move_to": "Move To",
	"menu.panel.move_to.left_bar": "Left Sidebar",
	"menu.panel.move_to.right_bar": "Right Sidebar",
	"menu.panel.move_to.top": "Top",
	"menu.panel.move_to.bottom": "Bottom",
	"menu.panel.move_to.float": "Float",
	"menu.panel.move_to.hidden": "Hide",
	"menu.panel.fold": "Collapse",
	"menu.mirror_painting.texture_center": "Origin",
	"menu.mirror_modeling.mirror_uv": "Mirror UV",
	"menu.animation_onion_skin.frames": "Frames",
	"menu.animation_onion_skin.select": "Select",
	"menu.animation_onion_skin.previous": "Previous",
	"menu.animation_onion_skin.next": "Next",
	"menu.animation_onion_skin.previous_next": "Previous + Next",
	"menu.animation_onion_skin.count": "Count",
	"menu.animation_onion_skin.interval": "Interval",
	"menu.animation_onion_skin_selective": "Selective Onion Skin",
	"menu.animation_onion_skin_selective.desc": "Only display onion skin for the selected part of the model",
	"edit.loop_cut.unit": "Unit",
	"edit.loop_cut.unit.size_units": "Size Units",
	"edit.loop_cut.unit.percent": "Percent",
	"edit.extrude_mesh_selection.direction": "Direction",
	"edit.extrude_mesh_selection.direction.outwards": "Outwards",
	"edit.extrude_mesh_selection.direction.average": "Average",
	"edit.extrude_mesh_selection.even_extend": "Even Extend",
	"edit.vertex_snap.align": "Align",
	"edit.vertex_snap.align.longest": "Longest Axis",
	"edit.vertex_snap.align.direction": "Direction from Pivot",
	"edit.vertex_snap.align.align_axis": "%0 Axis",
	"edit.vertex_snap.ignore_axis": "Ignore Axis",
	"codec.common.format": "Format",
	"codec.image.quality": "Quality",
	"panel.collections": "Collections",
	"modifier_actions.always": "Always Enabled",
	"modifier_actions.unless": "Unless %0",
	"settings.undo_selections": "Undo Selection",
	"settings.undo_selections.desc": "Track selection changes as a step in the undo history",
	"action.focus_on_selection.zoom": "Zoom to fit",
	"display.reference.tooting": "Horn Tooting",
	"settings.selection_tolerance": "Selection Tolerance",
	"settings.selection_tolerance.desc": "Size of the area that can be clicked to select an edge or vertex",
	"action.delete.keep_vertices": "Keep Edges/Vertices",
	"menu.mesh": "Mesh",
	"dialog.material_config.subsurface": "Subsurface Scattering",
	"dialog.material_config.subsurface_enabled.desc": "Use the MER map alpha channel for subsurface scattering",
	"settings.pick_combined_color": "Pick Combined Color",
	"settings.pick_combined_color.desc": "Pick the combined color of all layers at the respective pixel, instead of the color on the active layer",
	"action.split_rgb_into_layers": "Split RGBA Channels into Layers",
	"action.split_rgb_into_layers.desc": "Split the texture into additive layers, one for each RGBA channel",
	"dialog.project.java_block_version": "Format Version",
	"data.spline_mesh": "Spline",
	"data.billboard": "Billboard",
	"data.armature": "Armature",
	"data.armature_bone": "Armature Bone",
	"generic.reload": "Reload",
	"modifier_actions.subtract": "Subtract",
	"modifier_actions.reduced_intensity": "Fine-Tune",
	"modifier_actions.select_bone": "Select Bone",
	"modifier_actions.spline_select_multiple_points": "Select multiple Points or Handles",
	"modifier_actions.move_panel_without_docking": "Move without docking",
	"message.save_all_textures.message": "Do you want to save each of the following textures?",
	"message.save_all_textures.skip": "Skip",
	"dialog.add_spline.shape": "Shape",
	"dialog.add_spline.shape.segment": "Segment",
	"dialog.add_spline.shape.square": "Rectangle",
	"dialog.add_spline.shape.circle": "Circle",
	"dialog.add_spline.diameter": "Diameter",
	"dialog.add_spline.sides_tubular": "Tube Segments",
	"dialog.add_spline.sides_radial": "Ring Segments",
	"dialog.add_spline.radius": "Tube Radius",
	"dialog.add_spline.length": "Length",
	"dialog.add_spline.width": "Width",
	"dialog.plugins.revoke_permissions": "Revoke Permissions",
	"dialog.expression_editor.pretty_print": "Pretty Print",
	"dialog.expression_editor.minify": "Minify",
	"dialog.expression_editor.find_replace": "Find/Replace",
	"dialog.create_gif.show_gizmos": "Record Gizmos & Grid",
	"dialog.preview_options.title": "Preview Options",
	"dialog.preview_options.background": "Background",
	"dialog.preview_options.background.checkerboard": "Checkerboard",
	"dialog.preview_options.background.solid": "Solid",
	"dialog.preview_options.background.custom_color": "Custom Color",
	"dialog.preview_options.show_gizmos": "Show Gizmos",
	"dialog.skin.texture_source": "Texture Source",
	"dialog.skin.texture_source.template": "Generate Template",
	"dialog.skin.texture_source.load_texture": "Load from Minecraft",
	"dialog.skin.texture_file": "Texture File",
	"dialog.convert_skin.adjust_texture": "Adjust Texture",
	"dialog.settings.clear_profile_value": "Clear profile value",
	"layout.section.customize": "Customize",
	"layout.theme.configure": "Configure",
	"layout.color.elevated": "Elevated",
	"layout.color.elevated.desc": "Elevated UI elements, usually separated by drop shadow",
	"layout.file.watch_changes": "Watch Changes and Reload",
	"settings.autocomplete_code": "Autocomplete Code",
	"settings.autocomplete_code.desc": "Display autocomplete suggestions in code editors",
	"settings.detect_flipbook_textures": "Detect Flipbook Textures",
	"settings.detect_flipbook_textures.desc": "Automatically detect flipbook animated textures and preview them as animation",
	"settings.double_click_select_reference": "Select Reference Image on Double Click",
	"settings.double_click_select_reference.desc": "Double click the viewport to select a reference image",
	"settings.default_keyframe_interpolation": "Default Keyframe Interpolation",
	"settings.default_keyframe_interpolation.desc": "Select the default keyframe interpolation mode",
	"settings.color_picker_style": "Color Picker Style",
	"settings.color_picker_style.desc": "Select the style of the paint mode color picker",
	"settings.export_asset_paths": "Export Asset Paths",
	"settings.export_asset_paths.desc": "Select how paths to assets such as textures or animations get saved in .bbmodel files",
	"settings.export_asset_paths.relative": "Relative Paths",
	"settings.export_asset_paths.absolute": "Full Paths",
	"settings.export_asset_paths.both": "Relative & Full Paths (Texture only)",
	"settings.export_asset_paths.none": "No Export",
	"action.slider_spline_resolution": "Spline Resolution %0",
	"action.slider_spline_resolution.desc": "Change spline resolution on the %0 axis (%1)",
	"action.slider_spline_resolution.u.desc_precision": "Ring Segments",
	"action.slider_spline_resolution.v.desc_precision": "Tube Segments",
	"action.slider_spline_radius": "Spline Radius",
	"action.slider_spline_radius.desc": "Change spline Radius",
	"action.slider_spline_handle_tilt": "Handle Tilt",
	"action.slider_spline_handle_tilt.desc": "Change spline handle Tilt",
	"action.slider_spline_handle_size": "Handle Size",
	"action.slider_spline_handle_size.desc": "Change spline handle Size",
	"action.blend_mode.lighten": "Lighten",
	"action.blend_mode.darken": "Darken",
	"action.weight_brush": "Weight Brush",
	"action.weight_brush.desc": "Paint vertex weights on meshes for armature deformations",
	"action.convert_minecraft_skin_variant": "Convert Slim/Wide Skin",
	"action.convert_minecraft_skin_variant.desc": "Switch the skin model between the classic wide (steve) model and the slim (alex) model. Optionally auto-adjust the texture to fit the model",
	"action.custom_skin_poses": "Custom Skin Poses",
	"action.custom_skin_poses.desc": "Load a custom skin pose preset",
	"action.custom_skin_poses.update": "Update Pose",
	"action.custom_skin_poses.update.desc": "Overwrite the saved pose with the current pose of the model",
	"action.add_custom_skin_pose": "Add Custom Skin Pose",
	"action.add_custom_skin_pose.desc": "Save the current pose of the model as a pose preset",
	"action.export_stl": "Export STL",
	"action.export_stl.desc": "Export a STL model for 3D printing",
	"action.add_element": "Add Element",
	"action.add_element.desc": "Add a new element from the list of element types",
	"action.add_spline": "Add Spline",
	"action.add_spline.desc": "Adds a new spline",
	"action.add_billboard": "Add Billboard",
	"action.add_billboard.desc": "Adds a new billboard, a flat element that always faces towards the camera",
	"action.add_armature": "Add Armature",
	"action.add_armature.desc": "Adds an armature that allows deforming a mesh via animation",
	"action.add_armature_bone": "Add Armature Bone",
	"action.add_armature_bone.desc": "Adds a bone to the armature",
	"action.search_textures": "Search Textures",
	"action.search_textures.desc": "Search for textures by name",
	"action.search_animations": "Search Animations",
	"action.search_animations.desc": "Search for animations by name",
	"action.spline_selection_mode": "Spline Selection Mode",
	"action.spline_selection_mode.object": "Object",
	"action.spline_selection_mode.handles": "Handles",
	"action.spline_render_mode": "Geometry",
	"action.spline_render_mode.mesh": "Mesh",
	"action.spline_render_mode.path": "Path",
	"action.spline_render_mode.desc": "Which geometry this spline should render",
	"action.spline_uv_mode": "UV Style",
	"action.spline_uv_mode.length_accurate": "Length Accurate",
	"action.spline_uv_mode.uniform": "Uniform",
	"action.spline_uv_mode.per_segment": "Per Segment",
	"action.spline_uv_mode.desc": "How the spline's tube mesh should lay its UVs",
	"action.spline_ring_segments": "Ring Segments",
	"action.spline_ring_segments.desc": "How many subdivisions this Spline has per Tube Ring",
	"action.spline_tube_segments": "Tube Segments",
	"action.spline_tube_segments.desc": "How many subdivisions this Spline has along its path",
	"action.spline_tube_radius": "Tube Radius",
	"action.spline_tube_radius.desc": "Set the Spline's Tube Radius",
	"action.spline_display_space": "Display Space",
	"action.spline_display_space.desc": "Display spline space indicators on its path",
	"action.spline_handle_mode": "Spline Handle Mode",
	"action.spline_handle_mode.desc": "Which mode to use for transforming spline handles",
	"action.spline_handle_mode.aligned": "Aligned",
	"action.spline_handle_mode.free": "Free",
	"action.spline_handle_mode.mirrored": "Mirrored",
	"action.slider_weight_brush_size": "Weight Brush Size",
	"action.weight_brush_xray": "Weight Brush XRay Mode",
	"action.weight_brush_xray.desc": "When enabled, the weight brush will affect all vertices instead of just the ones that are visible on the surface",
	"action.apply_spline_rotation": "Apply Rotation",
	"action.apply_spline_rotation.desc": "Reset the element rotation of the spline, and apply it to the geometry instead",
	"action.extrude_spline_selection": "Extrude Spline",
	"action.extrude_spline_selection.desc": "Extrude the selected handle on all splines",
	"action.split_spline": "Split Spline",
	"action.split_spline.desc": "Splits the spline into two splines at the selected handle",
	"action.divide_spline_curve": "Divide Spline Segment",
	"action.divide_spline_curve.desc": "Splits the spline segment into two new segments with a new handle at their intersection",
	"action.set_vertex_weights": "Set Vertex Weights",
	"action.set_vertex_weights.desc": "Set the vertex weights of the selected vertices to a specific value on a certain armature bone",
	"action.calculate_vertex_weights": "Calculate Vertex Weights",
	"action.calculate_vertex_weights.desc": "Automatically assign vertex weights weights based on the position of the bones",
	"action.shelf_alignment": "Shelf Alignment",
	"action.shelf_alignment.desc": "Select the vertical alignment of items on the shelf",
	"action.shelf_alignment.top": "Top Alignment",
	"action.shelf_alignment.bottom": "Bottom Alignment",
	"action.view_mode.vertex_weight": "Vertex Weight",
	"action.view_mode.weighted_bone_colors": "Vertex Bone Colors",
	"action.create_animation_group": "Create Animation Group",
	"action.create_animation_group.desc": "Create a group of animations",
	"action.move_graph_keyframes_up": "Move Keyframe Graph Up",
	"action.move_graph_keyframes_down": "Move Keyframe Graph Down",
	"menu.skin": "Skin",
	"menu.text_edit.expression_editor": "Expression Editor",
	"menu.color_picker.picker_type.normal": "Normal Map",
	"menu.texture.flipbook_animation": "Flipbook Animation",
	"menu.panel.attach_to": "Attach To",
	"menu.animation.playing": "Playing",
	"menu.animation_file.save_as": "Save As",
	"menu.animator.quaternion_interpolation": "Quaternion Interpolation",
	"edit.extrude_spline_selection.extend": "Extend",
	"edit.divide_spline_curve.position": "Position",
	"group.bedrock_binding": "Binding",
	"group.cem_attach": "CEM Attach",
	"group.cem_model": "CEM Model",
	"group.cem_scale": "CEM Scale",
	"cube.rescale": "Rotation Rescale",
	"cube.rescale.desc": "Rescale cube to compensate for the rotation angle",
	"mesh.shading": "Shading",
	"mesh.shading.flat": "Flat",
	"mesh.shading.smooth": "Smooth",
	"spline_mesh.cyclic": "Cyclic",
	"spline_mesh.cyclic.desc": "Whether the selected spline should form a loop (Cycle)",
	"billboard.offset": "Offset",
	"billboard.facing_mode": "Facing Mode",
	"billboard.facing_mode.lookat": "Look At",
	"billboard.facing_mode.lookat_y": "Look At Y",
	"billboard.facing_mode.rotate": "Rotate",
	"billboard.facing_mode.rotate_y": "Rotate Y",
	"armature_bone.connected": "Connected",
	"reference_image.blueprint": "Locked Blueprint",
	"codec.image.alpha_channel": "Alpha Channel",
	"codec.image.animation_fps": "Animation FPS",
	"panel.palette": "Palette",
	"panel.keyframe.change_effect_file": "Change Effect File",
	"panel.transform": "Transform",
	"panel.element.spline_dimensions": "Spline Dimensions",
	"display.slot.on_shelf": "Shelf",
	"display.reference.shelf": "Shelf (All Slots)",
	"display.reference.shelf_left": "Shelf (Left Slot)",
	"display.reference.shelf_center": "Shelf (Center Slot)",
	"display.reference.shelf_right": "Shelf (Right Slot)",
	"message.newer_project_format_version.title": "Outdated client",
	"message.newer_project_format_version.message": "This file was saved in a newer version of Blockbench. Update to Blockbench %0 or newer to be able to open it correctly",
	"message.load_images.add_layer": "Add as Layer",
	"message.load_images.category.add_to_project": "Add to project",
	"message.load_images.category.new_project": "New project",
	"message.load_palette.title": "Load Palette",
	"message.load_palette.message": "Are you sure you want to load this palette? This will replace your current color palette.",
	"dialog.set_vertex_weights.weight": "Weight",
	"dialog.set_vertex_weights.overwrite": "Overwrite other bones",
	"action.element_render_order.short": "Render Order",
	"action.element_render_order.desc": "Render order of elements. This can help fix elements that are hidden behind other elements with transparent textures. Leave it on Auto for opaque elements.",
	"spline.shading.flat": "Flat",
	"spline.shading.smooth": "Smooth",
	"spline.shading": "Shading",
	"spline.shading.desc": "How this spline's tube should be shaded",
	"action.slider_weight_brush_limit": "Weight Brush Limit",
	"action.slider_weight_brush_limit.desc": "Set an upper limit for how much weight the weight brush can assign to a vertex",
	"action.weight_brush_blend_mode": "Weight Brush Blend Mode",
	"action.weight_brush_blend_mode.set": "Set",
	"action.weight_brush_blend_mode.add": "Add",
	"action.apply_texture_to_elements": "Apply Texture to Elements",
	"action.apply_texture_to_elements.desc": "Apply the selected texture to the selected elements",
	"menu.panel.reset_size": "Reset Size",
	"action.import_layer": "Import Layer",
	"action.import_layer.desc": "Import image files as layers",
	"menu.collection.open_file": "Open File",
	"layout.version": "Version",
	"settings.status_bar_transform_sliders": "Transform Sliders in Status Bar",
	"settings.status_bar_transform_sliders.desc": "Display the transform sliders toolbar of the selected tool in the status bar instead of using the Transform panel",
	"settings.default_bedrock_format": "Default Bedrock Format",
	"settings.default_bedrock_format.desc": "Select the default format to load Minecraft Bedrock models in, when no specific format can be detected from context.",
	"settings.limit_brush_opacity_per_stroke": "Limit Brush Opacity per Stroke",
	"settings.limit_brush_opacity_per_stroke.desc": "Limit the opacity that a brush can apply to the value of the opacity slider during each brush stroke. With a smooth brush this behavior can potentially lead to slight unwanted noise.",
	"action.merge_splines": "Merge Splines",
	"action.merge_splines.desc": "Merge multiple splines into one",
	"settings.default_java_block_version": "Default Java Block/Item Version",
	"settings.default_java_block_version.desc": "Default format version when creating new Java block/item models or opening files without format version",
	"data.bounding_box": "Bounding Box",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "Left-click slide horizontal",
	"keys.slide_lmb_vertical": "Left-click slide vertical",
	"keys.slide_rmb_horizontal": "Right-click slide horizontal",
	"keys.slide_rmb_vertical": "Right-click slide vertical",
	"message.recover_backup.unknown_project": "Unknown project",
	"message.recover_backup.discard_others": "Discard all others",
	"message.unsupported_file_extension.title": "File format not supported",
	"message.unsupported_file_extension.message": "Cannot open file %0, the format is not supported. You might need a plugin for this file type.",
	"message.unsupported_file_extension.open_in_default_program": "Open in default program",
	"dialog.project.uv_size": "UV Size",
	"dialog.collection.offset": "Offset",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Frames per second of the texture flipbook animation",
	"dialog.edit_uv_size.title": "Edit UV Size",
	"dialog.edit_uv_size.target": "Target",
	"dialog.edit_uv_size.adjust": "Adjust",
	"dialog.edit_uv_size.adjust.adjust_uv": "Counter UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "Counter UV & Scale",
	"dialog.edit_uv_size.adjust.keep": "Keep UV",
	"dialog.edit_uv_size.target_size": "Target UV Size",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Match Texture",
	"dialog.edit_uv_size.result": "Result",
	"dialog.edit_uv_size.result.textures": "Textures",
	"dialog.adjust_brightness_contrast.brightness": "Brightness",
	"dialog.adjust_brightness_contrast.contrast": "Contrast",
	"dialog.adjust_saturation_hue.saturation": "Saturation",
	"dialog.adjust_saturation_hue.hue": "Hue",
	"dialog.adjust_opacity.mode": "Mode",
	"dialog.adjust_opacity.mode.multiply": "Multiply",
	"dialog.adjust_opacity.mode.set": "Set",
	"dialog.bedrock_bounding_box.type": "Type",
	"dialog.bedrock_bounding_box.type.collision_box": "Collision",
	"dialog.bedrock_bounding_box.type.selection_box": "Selection Box",
	"dialog.bedrock_bounding_box.type.hitbox": "Hitbox",
	"dialog.bedrock_bounding_box.hitbox_note": "Please note that entity hitboxes only work up to a certain size and may not adapt to the rotation of the entity in-game.",
	"dialog.bedrock_bounding_box.collision_note": "Please note that entity collision boxes only support one centered shape with a square top profile.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "No bounding boxes exist in this project",
	"dialog.install_plugins_from_list.ids": "Plugin IDs",
	"dialog.install_plugins_from_list.info": "Install several plugins from a list of IDs. Before installing, please ensure that you actually need all plugins. Keeping inactive plugins can increase the risk of bugs and incompatibilities with future updates.",
	"dialog.copy_installed_plugins.details": "Include Details",
	"dialog.flip_animation.phase_offset": "Phase Offset",
	"dialog.flip_animation.phase_offset.off": "Off",
	"dialog.flip_animation.phase_offset.custom": "Custom",
	"dialog.flip_animation.clear_opposite": "Overwrite opposite",
	"settings.flipbook_textures_in_animation": "Play Flipbook Textures in Animation",
	"settings.flipbook_textures_in_animation.desc": "Preview animations on flipbook textures in sync with the animation timeline",
	"settings.display_uv": "Display UV Faces",
	"settings.display_uv.desc": "Select which UV faces are displayed in the UV editor",
	"settings.display_uv.selected_faces": "Only selected faces",
	"settings.display_uv.selected_elements": "All faces on selected elements",
	"settings.display_uv.all_elements": "All faces on all elements",
	"settings.local_position_values": "Local Position Values",
	"settings.local_position_values.desc": "Display all position values in the Transform panel in local space",
	"settings.transform_cube_from_center": "Transform Cubes from Center",
	"settings.transform_cube_from_center.desc": "Edit the cube position values from the center instead of the corner",
	"settings.color_picker_tool_switch": "Color Picker Tool Switch",
	"settings.color_picker_tool_switch.desc": "When picking a transparent pixel, switch to the eraser. When the eraser was previously selected and a color is picked, switch to the brush",
	"keybind.preview_scroll_zoom": "Zoom View",
	"keybind.uv_editor_scroll_zoom": "Zoom UV/2D Editor",
	"action.blend_mode.alpha_mask": "Alpha Mask",
	"action.swap_tools.hold": "Hold to swap (Color Picker)",
	"action.import_bedrock_voxel_shape": "Import Bedrock Voxel Shape",
	"action.import_bedrock_voxel_shape.desc": "Add a voxel shape from a json file to the current project",
	"action.export_bedrock_voxel_shape": "Export Bedrock Voxel Shape",
	"action.export_bedrock_voxel_shape.desc": "Export the bounding boxes in the project as a bedrock voxel shape file",
	"action.plugins_window_menu": "Menu",
	"action.copy_installed_plugins": "Copy Installed Plugins",
	"action.copy_installed_plugins.desc": "Generate and copy a list of the currently installed plugins",
	"action.install_plugins_from_list": "Install Plugins from List",
	"action.install_plugins_from_list.desc": "Install plugins from a list of plugin IDs",
	"action.add_bounding_box": "Add Bounding Box",
	"action.add_bounding_box.desc": "Adds a new bounding box",
	"action.split_alpha_into_layer": "Split Alpha Channel into Layer",
	"action.split_alpha_into_layer.desc": "Split the alpha channel of the texture into an alpha mask layer",
	"action.generate_bedrock_block_box": "Copy Collision/Selection Component",
	"action.generate_bedrock_block_box.desc": "Generate a collision or selection box component for Minecraft Bedrock Edition blocks",
	"action.generate_bedrock_entity_box": "Copy Collision/Hitbox Component",
	"action.generate_bedrock_entity_box.desc": "Generate a collision or custom hit test component for Minecraft Bedrock Edition entities",
	"action.refresh_texture": "Refresh Texture",
	"action.refresh_texture.desc": "Reload the texture from file",
	"action.move_uv_to_cursor": "Move UV to Cursor",
	"action.move_uv_to_cursor.desc": "Move the selected UV faces to the mouse cursor position",
	"action.edit_mode_uv_overlay": "Display All Elements",
	"action.round_keyframe_values": "Round Keyframe Values",
	"action.round_keyframe_values.desc": "Round all values of the selected keyframes",
	"action.keyframe_column_create.all_channels": "All Channels",
	"action.keyframe_column_create.all_channels.desc": "Initialize all channels with keyframes even if they had no keyframes previously",
	"action.add_all_to_timeline": "Add All to Timeline",
	"action.mirror_animating": "Mirror Animating",
	"action.mirror_animating.desc": "Mirror animation edits to the opposite side",
	"action.copy_animation_pose": "Copy Animation Pose",
	"action.copy_animation_pose.desc": "Copy all keyframes to replicate the current animation pose",
	"menu.texture.file_format": "File Format",
	"menu.texture.wrap_mode": "Wrap Mode",
	"menu.texture.wrap_mode.limited": "Restricted",
	"menu.texture.wrap_mode.repeat": "Repeat",
	"menu.texture.wrap_mode.clamp": "Clamp Edge",
	"edit.reparent_selection.adjust_position": "Preserve World Transform",
	"texture_mesh.texture_name": "Texture Name",
	"display.slot.embedded": "Embedded",
	"display.animate_preview": "Preview Animation",
	"display.reference.flower_pot": "Flower Pot"
}